import * as moment from 'moment';
	export class ObjectCheckupInfo {
		Id: number;
		LocationCheckupId: number;
		RentalObjectId: number;
		Status: ObjectCheckupStatus | undefined;
		Actions: CheckupActionInfo[] = [];
		Spareparts: CheckupSparePartInfo[] = [];
	}
	export class RentalInfo {
		BookingCode: string;
		PrimaryObjectTypeId: number;
		PickupLocationId: number;
		ReturnLocationId: number | undefined;
		PrimaryObjectTypeCategoryId: number | undefined;
		IsWebRental: boolean;
		UseInsurance: boolean;
		Note: string;
		Customer: CustomerInfo | undefined;
		SmartLock: SmartLockInfo | undefined;
		DiscountId: string;
		QueueIndex: number | undefined;
		WeekQueueIndex: number | undefined;
		QueuedAt: moment.Moment | undefined;
		CreatedAt: moment.Moment;
		ReturnedAt: moment.Moment | undefined;
		ExtraReceiptSkipped: boolean;
		ExtraReceiptExists: boolean;
		Price: PriceModel | undefined;
		ActivatedAt: moment.Moment | undefined;
		OutlandCode: string;
		ForeignCountry: string;
		AddedProductIds: number[] = [];
		AddedProducts: string;
		AlternativesSentAt: moment.Moment | undefined;
		AlternativesChangedAt: moment.Moment | undefined;
		CanceledAt: moment.Moment | undefined;
		Flagged: boolean;
		SignedAt: moment.Moment | undefined;
		DigitalSignature: string;
		Insurance: number;
		IsOnlinePayment: boolean;
		HasTicket: boolean;
		LocalPickupTime: moment.Moment;
		LocalReturnTime: moment.Moment;
		LocalReturnedAt: moment.Moment | undefined;
		BookingLat: number | undefined;
		BookingLng: number | undefined;
		RowVersion: string;
		LatestCSAction: string;
		InvoiceCode: string;
		InvoiceAccount: string;
		InvoiceCustomerName: string;
		InvoiceCustomerId: number | undefined;
		MetaData: string;
		PickupDevice: string;
		ReturnDevice: string;
		AIJudgement: boolean | undefined;
		AiEvaluatedAt: moment.Moment | undefined;
		CSJudgment: boolean | undefined;
		CSActionAt: moment.Moment | undefined;
		TravelRange: NuwielTravelRange | undefined;
		Id: number | undefined;
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		Status: RentalStatus | undefined;
		PickupLocation: LocationInfo | undefined;
		ReturnLocation: LocationInfo | undefined;
		PrimaryType: ObjectTypeInfo | undefined;
		ObjectId: number | undefined;
		RentalObject: RentalObjectInfo | undefined;
		IsOneWay: boolean;
		BindsAt: moment.Moment | undefined;
		BoundAt: moment.Moment | undefined;
	}
	export class RentalInfoBase {
		Id: number | undefined;
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		Status: RentalStatus | undefined;
		PickupLocation: LocationInfo | undefined;
		ReturnLocation: LocationInfo | undefined;
		PrimaryType: ObjectTypeInfo | undefined;
		ObjectId: number | undefined;
		RentalObject: RentalObjectInfo | undefined;
		IsOneWay: boolean;
		BindsAt: moment.Moment | undefined;
		BoundAt: moment.Moment | undefined;
	}
	export class AIQueueInfo {
		Id: string;
		RentalId: number;
		Type: AIQueueType | undefined;
		Status: number;
		CSResult: number | undefined;
		CSActionAt: moment.Moment | undefined;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment | undefined;
		AttemptCount: number;
		NextAttemptAt: moment.Moment | undefined;
		ProcessedAt: moment.Moment | undefined;
		FailedAt: moment.Moment | undefined;
		LastError: string;
	}
	export class BookingValidation {
		PickupErrorCode: BookingErrorCode | undefined;
		ReturnErrorCode: BookingErrorCode | undefined;
		PickupOpeningHours: OpenHours | undefined;
		ReturnOpeningHours: OpenHours | undefined;
		ValidPeriods: OpenHours[] = [];
		ErrorCode: BookingErrorCode | undefined;
		AggregatedResult: BookingErrorCode | undefined;
		BookingId: number | undefined;
		RequirePayment: boolean;
		PaymentURI: string;
		BookingInfoUri: string;
		CustomerBlockedReason: string;
		Message: string;
		OfferCreated: boolean;
	}
	export class MessageFormat {
		MessageId: string;
		MessageType: string;
		EntityId: string;
		CreatedAt: moment.Moment;
		StartAt: moment.Moment;
		Content: string;
	}
	export class MessageQueueInfo {
		Id: string;
		MessageTypeId: string;
		ReceiverId: string;
		Content: string;
		CreatedAt: moment.Moment;
		StartAt: moment.Moment | undefined;
		RetryCount: number;
		LastRetryAt: moment.Moment | undefined;
		LastErrorMessage: string;
		CompletedAt: moment.Moment | undefined;
		IsCompleted: boolean;
		EntityId: string;
		LastErrorCode: number | undefined;
		NextRetryAt: moment.Moment | undefined;
		MessageType: MessageTypeInfo | undefined;
		Receiver: ReceiverInfo | undefined;
	}
	export class MessageTypeInfo {
		Id: string;
		Name: string;
		Description: string;
	}
	export class ReceiverInfo {
		Id: string;
		ContextId: string;
		ContentType: WebHookFormat | undefined;
		DeliveryType: WebHookDeliveryType | undefined;
		WebHookSettings: string;
		NotificationEmail: string;
		ReceiverMessageTypes: ReceiverMessageTypeInfo[] = [];
		MessageTypes: MessageTypeInfo[] = [];
		ReceiverMessages: MessageQueueInfo[] = [];
		RentalLocationName: string;
	}
	export class ReceiverMessageTypeInfo {
		Id: string;
		ReceiverId: string;
		MessageTypeId: string;
		FilterConditions: string;
		Receiver: ReceiverInfo | undefined;
		MessageType: MessageTypeInfo | undefined;
	}
	export class U4FDiagramPercentageValues {
		PercentOfFree: number;
		PercentOfInsurance: number;
		PercentOfPreBooking: number;
	}
	export class ActiveOrderModel {
		Id: number;
		RegNo: string;
		OnRentDate: moment.Moment | undefined;
		OffRentDate: moment.Moment | undefined;
		ManufacturingDate: moment.Moment | undefined;
		Alias: string;
		NetAmount: number | undefined;
		XALCustomerNumber: string;
		UpdatedDt: moment.Moment | undefined;
		DeletedDt: moment.Moment | undefined;
		AxId: string;
		InventTransId: string;
		OriginalValue: number | undefined;
		ArtNo: string;
		SerialNo: string;
		DLLContractId: string;
		ContractType: number | undefined;
		IsTerminated: boolean;
		RentalId: string;
		ProductionId: string;
		ConfirmedDeliveryDt: moment.Moment | undefined;
		DeliveredAt: moment.Moment | undefined;
		Status: ContractStatus | undefined;
		CreatedDt: moment.Moment | undefined;
		StatusString: string;
		OffRentActionExists: boolean | undefined;
		NumberOfExtensions: number;
		ExtendTo: moment.Moment | undefined;
		CustomerName: string;
		ForceRepurchase: boolean;
		XalAccountNumber: string;
		Ownership: string;
	}
	export class ChecklistRepurchaseModel {
		HaveDllContractId: boolean;
		IsFinanced: boolean;
		IsNotInsurance: boolean;
		TerminationCreated: boolean;
		BuybackDatePassed: boolean;
	}
	export class ChecklistSoldModel {
		Id: number;
		TerminationCreated: boolean;
		InvoiceDatePassed: boolean;
		ContractType: number;
		IsRepurhased: boolean;
		TerminationTypeSell: boolean;
		IsNotInsurance: boolean;
		Price: boolean;
		NotAlreadySold: boolean;
		CustomerNotBlocked: boolean;
	}
	export class ChecklistTerminationModel {
		Id: number;
		TerminationCreated: boolean;
		ActionDate: boolean;
		IntegrationErrorNotExists: boolean;
	}
	export class ConfirmOrderModel {
	}
	export class ContractExtensionInfo {
		Id: string;
		ContractId: number;
		NewEndDate: moment.Moment;
		CreatedAt: moment.Moment;
		CreatedBy: string;
		IsProcessed: boolean;
		ProcessedAt: moment.Moment | undefined;
		Trailer: RentalContractInfo | undefined;
		SentAt: moment.Moment | undefined;
		AnnataId: string;
	}
	export class OrderCustomerModel {
		Id: number;
		Name: string;
		InvoiceName: string;
		AxCustomerNo: string;
		XalAccountNo: string;
		RentalLocationGroupId: number;
		LegalAddress: string;
		LegalZipCode: string;
		LegalCity: string;
		LegalAddressCustomerName: string;
		DeliveryAddress: string;
		DeliveryZipCode: string;
		DeliveryCity: string;
		DeliveryAddressCustomerName: string;
		InvoiceAddress: string;
		InvoiceZipCode: string;
		InvoiceCity: string;
		StationNo: string;
		Attention: string;
		PaymentMethod: string;
		BFIKNR: string;
		Phone: string;
		InvoiceAccount: string;
		OrgNo: string;
		Subsidiary: string;
		Country: string;
		Mail: string;
		IsEnabled: boolean;
		IsDeleted: boolean;
		IsDemo: boolean;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment;
		LegalOrgNo: string;
		PriceListId: number | undefined;
		TrailerList: string;
		RentalOrderList: string;
		CustomerNumber: string;
		Chain: string;
		SalesRepId: string;
		T4StationId: number | undefined;
		T4IsOneWay: boolean;
		UseT4: boolean;
		MobilePhone: string;
		ServicePartner: string;
		RepairPartner: string;
		ServicePartnerId: number;
		RepairPartnerId: number;
		UsedPartner: number | undefined;
		IsBlocked: boolean;
		T4ContextId: string | undefined;
		DisplayName: string;
		SpecialNote: string;
	}
	export class CustomerSettingsModel {
		T4: T4Settings | undefined;
		OneWay: OneWaySettings | undefined;
		Payment: PaymentSettings | undefined;
		Service: ServiceSettings | undefined;
	}
	export class T4Settings {
		LocationGroupId: number | undefined;
		ImplicitGroupId: number | undefined;
		ReviewRequestUri: string;
		T4DisplayName: string;
		IsUnmanned: boolean;
	}
	export class OneWaySettings {
		AllowOneWay: boolean;
		AllowSelfService: boolean;
		SoftLimit: number;
		HardLimit: number;
		Priority: number;
		OverrideLockStatus: boolean;
		OpenForPickup: boolean;
		OpenForReturn: boolean;
		ClosedReason: string;
	}
	export class ServiceSettings {
		IsServicePartner: boolean;
		RequestEmail: string;
		ServicePartnerId: number | undefined;
		UsedPartner: number | undefined;
		ServiceZone: number | undefined;
		RepairPartnerId: number | undefined;
	}
	export class PaymentSettings {
		UsingPaythrough: boolean;
		InvoiceEmail: string;
		SupplierAccount: string;
		PayoutInfo: string;
	}
	export class RentalContractInfo {
		Id: number;
		Alias: string;
		OffRentActionExists: boolean | undefined;
		RegNo: string;
		Type: string;
		OnRentDate: moment.Moment;
		OffRentDate: moment.Moment;
		PricePerMonth: number;
		ArtNo: string;
		RentalId: string;
		OriginalValue: number;
		RemainingValue: number;
		Terminate: boolean | undefined;
		Price: number | undefined;
		TerminationId: number | undefined;
		TerminationDate: moment.Moment | undefined;
		TerminationType: number | undefined;
		Expired: boolean;
		Customer: OrderCustomerModel | undefined;
		OwnerId: string;
		IsTerminationProcessed: boolean;
		Status: ContractStatus | undefined;
		SalesRepId: string;
		ResidualValue: number;
		ExtendedTo: moment.Moment | undefined;
		VehicleId: string | undefined;
		CustomerId: number;
		ErrorReason: string;
		DeletedDt: moment.Moment | undefined;
		OriginalStartDate: moment.Moment;
		OriginalEndDate: moment.Moment;
	}
	export class CustomerTrailerExcelModel {
		CustomerName: string;
		RegNo: string;
		Alias: string;
		PricePerMonth: number | undefined;
		StartWeek: moment.Moment | undefined;
		TerminationDate: moment.Moment | undefined;
	}
	export class DeletedOrderSummary {
		Id: number;
		CustomerName: string;
		CustomerAddress: string;
		CustomerId: number | undefined;
		Status: TurboOrderStatus | undefined;
		StatusName: string;
		UpdatedDt: moment.Moment | undefined;
		ConfirmedDt: moment.Moment | undefined;
		TerminationDt: moment.Moment | undefined;
		TerminationType: number;
		OwnerId: string;
		Customer: OrderCustomerModel | undefined;
		NumberOfObjects: number;
		OrderValue: number;
		CreatedDt: moment.Moment | undefined;
		TotalPrice: number | undefined;
	}
	export class DLLOrderModelBase {
		input: DLLOrderModel | undefined;
	}
	export class DLLOrderModel {
		Username: string;
		Password: string;
		CustomerOfferID: string;
		SalesPersonEmail: string;
		Billing: string;
		InterestType: string;
		PeriodLength: number;
		Duration: number;
		ResidualClause: string;
		ExternalReference: string;
		SendCreditRequest: boolean;
		CalculateByRent: boolean;
		Products: DLLProduct[] = [];
		CustomerOrgNo: string;
		CustomerInfo: DLLCustomerInfo | undefined;
		InvoiceAddress: DLLInvoiceAddress | undefined;
		InstallationAddress: DLLInstallationAddress | undefined;
	}
	export class DLLProduct {
		Type: string;
		Name: string;
		Specification: string;
		Quantity: number;
		Price: number;
		Rent: number;
	}
	export class DLLInvoiceAddress {
		CoName: string;
		Address: string;
		City: string;
		ZipCode: string;
	}
	export class DLLInstallationAddress {
		Address: string;
		Location: string;
	}
	export class DLLCustomerInfo {
		Contact: string;
		PhoneNo: string;
		Email: string;
		Fax: string;
	}
	export class OrderEntityAttachmentInfo {
		Id: string;
		EntityId: string;
		CreatedAt: moment.Moment;
		SentTo: string;
		Subject: string;
		Content: string;
		ContentType: OrderEntityAttachmentType | undefined;
		EntityEvent: OrderEntityEventInfo | undefined;
	}
	export enum OrderEntityAttachmentType {
		Text = 0,
		Html = 1,
	}
	export class OrderEntityEventInfo {
		Id: string;
		EntityId: string;
		EntityTypeId: string;
		CreatedAt: moment.Moment;
		EventId: number;
		Notes: string;
		Metadata: string;
		UserId: string;
		SignedBy: string;
		EntityType: OrderEntityTypeInfo | undefined;
		EventType: string;
		RentalObjectId: number | undefined;
		IsCSAction: boolean | undefined;
		AttachmentExists: boolean;
		EntityAttachmentInfos: OrderEntityAttachmentInfo[] = [];
	}
	export class EntityQueueInfo {
		Id: string;
		EntityId: string;
		EntityType: EntityQueueType | undefined;
		CreatedAt: moment.Moment | undefined;
		StartAt: moment.Moment | undefined;
		RetryCount: number | undefined;
		LastRetryAt: moment.Moment | undefined;
		LastErrorMessage: string;
		CompletedAt: moment.Moment | undefined;
		LastErrorCode: number | undefined;
		NextRetryAt: moment.Moment | undefined;
	}
	export class OrderEntityTypeInfo {
		Id: string;
		Name: string;
		Description: string;
	}
	export class IntegrationLogInfo {
		Id: number;
		Layer: string;
		TimeStamp: moment.Moment;
		UserId: string;
		Message: string;
		StackTrace: string;
		InnerMessage: string;
		InnerStackTrace: string;
		Type: string;
		Info: string;
		EntityId: string;
		AnnataErrorMessage: string;
	}
	export class ItemOrderInfo {
		Id: number;
		ArticleNo: string;
		Description: string;
		HasReplacmentKit: boolean;
		RequireLock: boolean;
		RequireTags: boolean;
		RequireGps: boolean;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment | undefined;
		IsEnabled: boolean;
		Country: string;
		Concept: string;
	}
	export class OrderCustomerInfo {
		Id: number;
		LegalOrgNo: string;
		RentalLocationGroupId: number;
		Longitude: number | undefined;
		Latitude: number | undefined;
		Distance: number | undefined;
		Phone: string;
		DeliveryZipCode: string;
		DeliveryCity: string;
		DeliveryAddressCustomerName: string;
		DeliveryAddress: string;
		InvoiceName: string;
		InvoiceZipCode: string;
		InvoiceCity: string;
		InvoiceAddressCustomerName: string;
		InvoiceAddress: string;
		Email: string;
		SalesRep: SalesRepInfo | undefined;
		SalesRepId: string;
		MobilePhone: string;
		ServicePartnerId: number | undefined;
		RepairPartnerId: number | undefined;
		UsedPartner: number | undefined;
		PricelistId: number | undefined;
		PricelistTitle: string;
		AxCustomerNo: string;
		SpecialNote: string;
	}
	export class OrderFilter {
		customerId: number | undefined;
		status: number | undefined;
	}
	export class PendingDeviceInfo {
		Id: string;
		UpcomingRegNoId: string;
		LockId: string;
		DeviceType: DeviceType | undefined;
		BluetoothMAC: string;
		CreatedAt: moment.Moment | undefined;
		CreatedBy: string;
		SerialNo: string;
		InvoiceAccount: string;
		IsT4Connected: boolean;
		T4ConnectedDate: moment.Moment | undefined;
		IglooLock: boolean;
	}
	export class RentalOrderSummary {
		Id: number;
		CustomerName: string;
		CustomerAddress: string;
		CustomerId: number | undefined;
		Status: TurboOrderStatus | undefined;
		XalAccountNo: string;
		DllId: string;
		StatusName: string;
		UpdatedDt: moment.Moment;
		ConfirmedDt: moment.Moment | undefined;
		DeliveryDt: moment.Moment | undefined;
		OwnerId: string;
		OrderType: number | undefined;
		Customer: OrderCustomerModel | undefined;
		NumberOfObjects: number;
		OrderValue: number;
	}
	export class UserDropDownModel {
		Id: string;
		UserName: string;
	}
	export class CancelOrderModel {
		Id: number;
		Status: number;
		UpdatedDt: moment.Moment | undefined;
		CanceledDt: moment.Moment | undefined;
	}
	export class SendToAxOrderModel {
		Id: number;
		Status: number;
		UpdatedDt: moment.Moment | undefined;
		SentToAxDt: moment.Moment | undefined;
		ConfirmedDt: moment.Moment | undefined;
	}
	export enum TerminationType {
		Sell = 1,
		Transport = 3,
		SwitchWithNew = 4,
		ChangeOwner = 5,
		ToBeDetermined = 6,
		OneWay = 7,
		Extend = 8,
		Forget = 100,
	}
	export class TerminationOrderInfo {
		CustomerId: number | undefined;
		TerminationType: TerminationType | undefined;
		Id: number;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment | undefined;
		Insurance: boolean;
		Comment: string;
		InvoiceAddress: string;
		InvoiceZipCode: string;
		InvoiceCity: string;
		InvoiceName: string;
		DeliveryAddress: string;
		DeliveryZipCode: string;
		DeliveryCity: string;
		DeliveryName: string;
		Phone: string;
		Contact: string;
		TerminateAt: moment.Moment | undefined;
		InvoiceAt: moment.Moment | undefined;
		TransferOwnershipAt: moment.Moment | undefined;
		Rows: TerminationRowInfo[] = [];
		UpdatedBy: string;
		CreatedBy: string;
		ExtendAt: moment.Moment | undefined;
		Customer: OrderCustomerModel | undefined;
		IsTransferFullOwnership: boolean;
		ReceivingStationInvoiceEmail: string;
		IncomingContactPerson: string;
		SignatoryName: string;
		SignatoryEmail: string;
	}
	export class TerminationRowInfo {
		TrailerId: number;
		Trailer: RentalContractInfo | undefined;
		Price: number;
		LowMargin: boolean;
		IsTerminated: boolean;
		IsProcessed: boolean;
		IsTransfered: boolean;
		IsCancelled: boolean;
		CancelledAt: moment.Moment | undefined;
		CancelledBy: string;
		Id: number;
		AnnataId: string;
		ContractExtension: ContractExtensionInfo | undefined;
	}
	export class ViewPriceListModel {
		Id: number;
		Title: string;
		Type: string;
		Relation: string;
		Fees: string;
		Rows: ViewPriceListRowModel[] = [];
		DefaultLength: number | undefined;
		OptionalServiceFee: boolean;
		ServiceCost: number | undefined;
		DllDealId: string;
		ResidualValue: number;
	}
	export class ViewPriceListRowModel {
		Id: number;
		PriceListId: number;
		ArticleNo: string;
		Description: string;
		PricePerMonth: number | undefined;
		SalesPrice: number | undefined;
		ServiceFee: number | undefined;
		ConceptFee: number | undefined;
	}
	export class ViewOrderModel {
		Id: number;
		OrgNo: string;
		Status: number;
		CreatedDt: moment.Moment;
		UpdatedDt: moment.Moment | undefined;
		ConfirmedDt: moment.Moment | undefined;
		CustomerId: number | undefined;
		Rate: number | undefined;
		OwnerId: string;
		CreatedBy: string;
		DLLId: string;
		AxId: string;
		OrderType: number;
		PriceListId: number | undefined;
		StripingManual: string;
		StripingMisc: string;
		StripingMiscInfo: string;
		MiscInfo: string;
		Months: number;
		Phone: string;
		LegalAddressCustomerName: string;
		LegalAddress: string;
		LegalZipCode: string;
		LegalCity: string;
		LegalCountry: string;
		InvoiceName: string;
		InvoiceStationNo: string;
		InvoiceAddress: string;
		InvoiceZipCode: string;
		InvoiceCity: string;
		InvoiceAccount: string;
		PaymentMethod: string;
		BFIKNR: string;
		InvoiceMail: string;
		DeliveryAddressCustomerName: string;
		DeliverySubsidiary: string;
		DeliveryAddress: string;
		DeliveryZipCode: string;
		DeliveryCity: string;
		DeliveryContact: string;
		DeliveryPhone: string;
		ArticlePricesEditable: boolean;
		OrderRows: ViewOrderRowsModel[] = [];
		PriceList: ViewPriceListModel | undefined;
		Customer: OrderCustomerModel | undefined;
		RequestedStartDate: moment.Moment | undefined;
		RequestedDeliveryDate: moment.Moment | undefined;
		LegalOrgNo: string;
		AgreementDocumentExists: boolean;
		Duration: number;
		PaymentAtBeginningOfPeriod: boolean;
		DeliveryEmail: string;
		AddServiceFee: boolean;
		Concept: string;
		Ownership: string;
		RentalOrderId: string;
		SalesOrderId: string;
	}
	export class ViewOrderRowsModel {
		Id: number;
		ArticleNo: string;
		Alias: string;
		Description: string;
		Amount: number;
		IsStandardArticle: boolean;
		SalesPrice: number | undefined;
		ConceptFee: number | undefined;
		ServiceFee: number | undefined;
		TotalCost: number;
		OriginalValue: number | undefined;
		BuyBackValue: number | undefined;
		ReplacementCount: number | undefined;
	}
	export class StakeholderModel {
		Id: number;
		StakeholderId: number;
		CustomerId: number;
		Percentile: number;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment | undefined;
		IsDeleted: boolean | undefined;
		DeletedAt: moment.Moment | undefined;
		Customer: OrderCustomerModel | undefined;
		Stakeholder: OrderCustomerModel | undefined;
	}
	export class TrailerInspectionInfo {
		ContractId: number;
		CustomerName: string;
		SerialNumber: string;
		RentalId: string;
		CreatedDt: moment.Moment | undefined;
		NextInspectionDate: moment.Moment | undefined;
		Status: ContractStatus | undefined;
	}
	export class UpcomingRegistrationNumberInfo {
		Id: string;
		RegNo: string;
		SerialNo: string;
		CreatedAt: moment.Moment | undefined;
		CreatedBy: string;
		PendingDevices: PendingDeviceInfo[] = [];
	}
	export class VehicleInfo {
		Id: string;
		SerialNo: string;
		RegNo: string;
		ArtNo: string;
		ArtDescription: string;
		Status: number | undefined;
		ManufacturingDate: moment.Moment | undefined;
		IsDLL: boolean;
		IsRepurhased: boolean;
		IsSold: boolean;
		IsScrapped: boolean;
		PurchaseDate: moment.Moment | undefined;
		PurchaseId: string;
		SellDate: moment.Moment | undefined;
		SalesId: string;
		Contracts: RentalContractInfo[] = [];
		Comment: string;
		LastKnownPosition: number | undefined;
		OverrideItemId: string;
		RegistrationDate: moment.Moment | undefined;
		OriginalValue: number | undefined;
		BuyBackValue: number | undefined;
	}
	export class ActivityPeriodSummary {
		Bookings: DateValue[] = [];
		WebBookings: DateValue[] = [];
		StationBookings: DateValue[] = [];
		Pickups: DateValue[] = [];
		Returns: DateValue[] = [];
		Cancellations: DateValue[] = [];
		CustomerCancellations: DateValue[] = [];
		StationCancellations: DateValue[] = [];
		AutoCancellations: DateValue[] = [];
		PickupsPY: DateValue[] = [];
	}
	export class ChartConfig {
		Accumulate: boolean;
		ColorSettings: ColorSettings | undefined;
		Unit: string;
		YAxisId: string;
		SuggestedMin: number;
		SuggestedMax: number;
	}
	export class ColorSettings {
		UseSameBackground: boolean;
		BackgroundColor: string;
		BorderColor: string;
	}
	export class DateChartData {
		ChartSeries: DateValue[][] = [];
		Config: ChartConfig | undefined;
	}
	export class ChartData {
		Labels: string[] = [];
		ChartSeries: number[][] = [];
		Config: ChartConfig | undefined;
	}
	export class DateValue {
		x: string;
		y: number;
	}
	export class PivotData {
		GroupableFields: string[] = [];
		FilterableFields: string[] = [];
	}
	export class RentalKPI {
		Key: string;
		Value: number;
		RelatedValue: number;
		Delta: number;
	}
	export class ReportInfo {
		Id: string;
		ContextId: string;
		Category: string;
		FriendlyName: string;
		TranslateFriendlyName: boolean;
		IsSchedulable: boolean;
	}
	export class ReportRunInfo {
		Id: string;
		ContextId: string;
		From: moment.Moment;
		To: moment.Moment;
		RunTime: moment.Moment | undefined;
		Format: ReportFormat | undefined;
		Uri: string;
		OrderedAt: moment.Moment;
		ErrorMessage: string;
	}
	export class TimeChartSeries {
		Date: moment.Moment;
		Value: number;
		Config: string;
	}
	export class ChartSeries {
		PrimaryDataset: number;
		Label: string;
		Value: number;
		Config: string;
	}
	export enum LockCommandResult {
		Success = 0,
		Failed = 1,
		ClientNotConnected = 2,
		Exception = 3,
		NotAuthenticated = 4,
		Timeout = 5,
		NotSet = 6,
		ClientBusy = 7,
	}
	export class ContentTemplateInfo {
		Key: string;
		Name: string;
		Description: string;
		ModelProperties: String[] | undefined;
		Content: string;
		IsDefined: boolean;
	}
	export class Country {
		Name: string;
		Code: string;
		Lng: number | undefined;
		Lat: number | undefined;
	}
	export class EmailTemplateInfo {
		Id: string;
		OwnerId: string;
		Key: string;
		Type: ContentType | undefined;
		Format: ContentFormat | undefined;
		Condition: string;
		FriendlyName: string;
		Content: string;
	}
	export class GeneralSetting {
		DataType: string;
		BoolValue: boolean;
		StringValue: string;
	}
	export enum SettingResult {
		NotFound = 0,
		Found = 1,
	}
	export class LanguageInfo {
		Id: number;
		Name: string;
		Code: string;
		Label: string;
		T4FlagUrl: string;
		AppsFlagUrl: string;
		ShowLanguage: boolean;
	}
	export class LocationGroupInfo {
		Id: number;
		Name: string;
		ContextId: string;
		ChildGroups: LocationGroupInfo[] = [];
	}
	export class GroupLocationHierarchyInfo {
		Concepts: LocationGroupInfo[] = [];
		Groups: LocationGroupInfo[] = [];
		Locations: LocationInfo[] = [];
	}
	export class ClientSettings {
		AllowSms: boolean;
		RentalLocationId: number | undefined;
		RentalLocationGroupId: number | undefined;
		TimeZoneId: string;
		Language: string;
		Country: string;
		Currency: string;
		IsLocal: boolean;
		IsOneWay: boolean;
		GoogleApiKey: string;
		CanEditPricelists: boolean;
		Version: TurboVersion | undefined;
		Objects: ObjectSettings | undefined;
		Bookings: BookingSettings | undefined;
		CustomerSettings: CustomerContextSettings | undefined;
		CustomerFormValidation: string;
		ContextId: string | undefined;
		GDPRTerms: string;
		DefaultLatitude: number;
		DefaultLongitude: number;
		MaxBookingsPerDay: number;
		MaximumConcurrentBookings: number;
		UsePinFromLocalGroup: boolean;
		ShowNearbyOptions: boolean;
		CanOrderService: boolean;
		RequireSignIn: boolean;
		PartnerCampaignEnabled: boolean;
	}
	export class BookingSettings {
		AllowChangeWhenDelayed: boolean;
		DefaultBookingLength: number;
		DigitalSignatureProvider: string;
		UseDigitalSignature: boolean;
		RequireDigitalSignature: boolean | undefined;
		EnableRentFreeWhenClosed: boolean | undefined;
		EarlyPickupInMinutes: number;
		SupportsPaymentRequests: boolean;
	}
	export class ObjectSettings {
		AutoDisableOnNewIssue: boolean;
	}
	export class ObjectTypeClassAttributesInfo {
		Id: number;
		ObjectTypeClassId: number;
		Key: string;
		DataType: string;
		IsTranslatable: boolean;
		Name: string;
		Unit: string;
		Shorthand: string;
		TypeAttribute: TypeAttributeInfo | undefined;
	}
	export class ObjectTypeClassInfo {
		Id: number;
		Name: string;
		Description: string;
		ContextId: string | undefined;
		OverridesClassId: number | undefined;
		Attributes: ObjectTypeClassAttributesInfo[] = [];
	}
	export class RightsInfo {
		Id: string;
		Category: string;
		Description: string;
		Name: string;
		Value: RightsValue | undefined;
	}
	export enum RightsValue {
		False = 0,
		True = 1,
		NotSet = 2,
	}
	export class Role {
		Id: string;
		Name: string;
	}
	export class SafetyCheckQuestionInfo {
		Id: number;
		Key: string;
		Name: string;
		SortOrder: number;
		TypeClassId: number;
	}
	export class SetupLocationInfo {
		ContextId: string | undefined;
		Location: string;
		Group: string;
		IsActiveInApp: boolean | undefined;
		IsActiveInTysse: boolean | undefined;
		IsActiveInBrenderupRental: boolean | undefined;
		AvailableOnline: boolean | undefined;
		AllTrailersAvailableOnline: boolean | undefined;
		TotalTrailerCount: number;
		OnlineTrailerCount: number;
		NotOnlineTrailers: string[] = [];
	}
	export class ShortLinkHitsInfo {
		Id: number;
		Pattern: string;
		KeyParameter: string;
		QueryString: string;
	}
	export class T4PricelistInfo {
		Id: number;
		Title: string;
		Type: ProductType | undefined;
		IsActive: boolean;
		ValidFrom: moment.Moment;
		ValidThrough: moment.Moment | undefined;
		OnlineBookingFee: number | undefined;
		OfflineBookingFee: number | undefined;
		InPlaceBookingFee: number | undefined;
		FreeRentalDays: number | undefined;
		FreeRentalHours: number | undefined;
		ExcessPerHour: number | undefined;
		ExcessPerDay: number | undefined;
		OneTimeExcessFee: number | undefined;
		IgnoreExcessRent: boolean;
		AcceptedOverdueInMinutes: number;
		IsRentalLocationGroup: boolean;
		RentalLocationGroupId: number | undefined;
		RentalLocationGroupName: string;
		IsRentalLocation: boolean;
		RentalLocationId: number | undefined;
		RentalLocationName: string;
		Intervals: T4PriceListInterval[] = [];
		Prices: T4Price[] = [];
	}
	export class T4PriceListInterval {
		Id: number;
		PriceListId: number;
		Interval: number;
		Unit: number;
		IsBaseInterval: boolean;
	}
	export class T4Price {
		PriceListId: number;
		ObjectTypeId: number;
		IntervalId: number;
		Price: number;
		ObjectType: ObjectTypeInfo | undefined;
	}
	export class T4SettingsPage {
		Key: string;
		Sections: T4SettingsSection[] = [];
		SortOrder: number;
	}
	export class T4SettingsSection {
		Key: string;
		Condition: string;
		Settings: T4Setting[] = [];
		SortOrder: number;
	}
	export class T4Setting {
		Key: string;
		Name: string;
		Description: string;
		SortOrder: number;
		ValidValues: T4SettingValue[] = [];
		Control: ControlType | undefined;
		ReadOnly: boolean;
		Value: any;
		OriginalValue: any;
		IsDefined: boolean;
		EffectiveValue: any;
		FinalSetting: boolean;
	}
	export class T4SettingValue {
		Id: string;
		Name: string;
	}
	export class TrailerPointInfo {
		TrailerPointRadius: number;
		TrailerPointLatitude: number;
		TrailerPointLongitude: number;
	}
	export class TypeAttributeInfo {
		Id: number;
		RentalObjectTypeId: number;
		AttributeId: number;
		AttributeValue: string;
	}
	export class WebHookSettings {
		AdminEmail: string;
		WebHooks: WebHook[] = [];
	}
	export class WebHook {
		Event: WebHookEvent | undefined;
		Uri: string;
		Username: string;
		Password: string;
	}
	export class AssetHistory {
		Position: string;
		PositionIsSG: boolean;
		StartTime: moment.Moment;
		EndTime: moment.Moment | undefined;
		CreatedBy: string;
		ClosedBy: string;
		Action: number;
	}
	export class AssetTransactionInfo {
		Id: string;
		AssetId: string;
		ContextId: string;
		StartDate: moment.Moment;
		EndDate: moment.Moment | undefined;
		InvoiceStartDate: moment.Moment | undefined;
		LastInvoiceDate: moment.Moment | undefined;
		InvoiceCount: number;
		InvoiceSum: number;
		SerialId: string;
		CreatedBy: string;
		ClosedBy: string;
		ActionName: string;
	}
	export class CheckupActionInfo {
		Id: number;
		ObjectCheckupId: number;
		DamageId: number;
		DamageType: DamageType | undefined;
		Comment: string;
		Checkup: ObjectCheckupInfo | undefined;
	}
	export class CheckupInfo {
		TrailerId: number;
		Actions: CheckupActionInfo[] = [];
		Status: ObjectCheckupStatus | undefined;
	}
	export class CheckupSparePartInfo {
		Id: number;
		ObjectCheckupId: number;
		ItemId: string;
		ItemCount: number;
	}
	export class DamageInfo {
		TrailerId: number;
		DamageId: number;
		DamageType: DamageType | undefined;
		Description: string;
		ImageUris: string[] = [];
		SavedAt: moment.Moment | undefined;
		RentalLocationName: string;
		RentalLocationGroupName: string;
		RegNo: string;
		ModelTitle: string;
		HandledCS: boolean;
		HandledSG: boolean;
		IsEnabled: boolean;
		IsDisabledByAdmin: boolean;
		Count: number;
		ContextId: string | undefined;
		AIComments: string[] = [];
	}
	export class InsuranceSetOffLine {
		Id: string;
		InsuranceId: number;
		Status: ServiceRequestStatus | undefined;
		ObjectId: number;
		OnRentDate: moment.Moment;
		OffRentDate: moment.Moment;
		ManufacturingDate: moment.Moment;
		ObjectName: string;
		LocationId: number;
		LocationName: string;
		IncidentDate: moment.Moment;
		Finance: RequestFinance | undefined;
		Repurchase: boolean;
		Country: string;
		InsuranceValue: number;
		IsRepurchased: boolean;
		ModelName: string;
		IsTaggedStolen: boolean;
	}
	export class InventoryStatus {
		ServiceGuyId: string;
		Firstname: string;
		Lastname: string;
		CompanyName: string;
		LocationId: number;
		LocationName: string;
		ServiceGuyType: string;
		LocationCount: number;
		OkItems: number;
		WarningItems: number;
		LowItems: number;
	}
	export class InventoryAssetInfo {
		Id: string;
		ServiceGuyId: string;
		AssetId: string;
		Status: number;
		CreatedAt: moment.Moment;
		DeletedAt: moment.Moment | undefined;
		Owner: ServiceGuyInfo | undefined;
		SerialId: string;
		SGName: string;
		CreatedBy: string;
		CreatedByName: string;
		ClosedBy: string;
		CloseByName: string;
		ContextId: string;
		Position: string;
		Trailer: string;
	}
	export enum InventoryAssetsStatus {
		Transfer = 0,
		Scrap = 1,
	}
	export class InventoryDelta {
		ItemId: string;
		Delta: number;
	}
	export class InventoryItemInfo {
		ServiceGuyId: string;
		ItemId: string;
		Item: ItemInfo | undefined;
		OnHand: number;
		StockSetting: ServiceGuyTypeStockSettingInfo | undefined;
		Owner: ServiceGuyInfo | undefined;
	}
	export class ItemInfo {
		ItemId: string;
		Name: string;
		OrderAmount: number;
	}
	export class LocationCheckupInfo {
		Id: number;
		ServiceGuyId: string;
		PerformedAt: moment.Moment;
		LocationId: number;
		ServiceGuy: ServiceGuyInfo | undefined;
		Location: LocationInfo | undefined;
		Objects: ObjectCheckupInfo[] = [];
	}
	export class LockLogInfo {
		LockId: string;
		TimeStamp: moment.Moment;
		Logs: string;
		Tags: string;
		RentalId: number | undefined;
	}
	export class RentalObjectSecurityCheckInfo {
		Id: number;
		RentalObjectId: number;
		RentalId: number;
		SavedAt: moment.Moment;
		JsonData: string;
		IsReturn: boolean;
		IsHandledBySG: boolean;
		IsHandledByCS: boolean;
		RentalObject: RentalObjectInfo | undefined;
	}
	export class RequestDetails {
		Id: string;
		RequestNo: number;
		InsuranceId: number | undefined;
		RentalObjectId: number;
		RentalObject: RentalObjectInfo | undefined;
		ServiceLocationId: number | undefined;
		ServiceLocation: ServiceLocationInfo | undefined;
		ObjectLocation: LocationInfo | undefined;
		CreatedAt: moment.Moment;
		Description: string;
		Status: ServiceRequestStatus | undefined;
		StatusDate: moment.Moment | undefined;
		ExpectedResolveDate: moment.Moment | undefined;
		ActualResolveDate: moment.Moment | undefined;
		Events: RequestEventDetails[] = [];
		Tags: String[] | undefined;
		IsOneWay: boolean;
		ImageIds: string;
		IncidentDate: moment.Moment | undefined;
		ContactFirstName: string;
		ContactLastName: string;
		ContactEmail: string;
		ContactPhone: string;
		RecordNumber: string;
		IsInsurance: boolean;
		IsClaim: boolean;
		ClaimId: string;
		LFInvoiced: boolean;
		LFInvoicedDate: moment.Moment | undefined;
		SparePartsCost: number | undefined;
		SparePartsDiscount: number | undefined;
		TransportCost: number | undefined;
		LaborCost: number | undefined;
		SelfRisk: number | undefined;
		InvoiceLF: boolean;
		SalesPrice: number | undefined;
		InsuranceValue: number;
		ResidualValue: number;
		Country: string;
		InsuranceTags: string;
		IsRepurchased: boolean;
		Owner: string;
		DiarieNumber: number | undefined;
		ServiceDocument: string;
		SGTypeName: string;
		SGTypeDescription: string;
	}
	export class RequestEventDetails {
		Id: string;
		RequestId: string;
		CreatedAt: moment.Moment;
		Createdby: string;
		Status: ServiceRequestStatus | undefined;
		Note: string;
	}
	export class RequestFinance {
		SpareParts: number;
		SparePartsDiscount: number;
		SparePartsTotal: number;
		Transport: number;
		Labor: number;
		RedemptionValue: number;
		OriginalValue: number;
		Depreciation: number;
		TotalRepairs: number;
		TotalCosts: number;
		SalesValue: number;
		SelfRisk: number;
		TotalValue: number;
	}
	export class RequestUpdate {
		RequestId: string;
		Description: string;
		NewStatus: ServiceRequestStatus | undefined;
		Comment: string;
		ExpectedResolveDate: moment.Moment | undefined;
		Tags: String[] | undefined;
		IsInsurance: boolean | undefined;
		SparePartsCost: number | undefined;
		SparePartsDiscount: number | undefined;
		Transport: number | undefined;
		Labor: number | undefined;
		SelfRisk: number | undefined;
		SalesPrice: number | undefined;
		activateObject: boolean | undefined;
		ServicePartner: number | undefined;
		InsuranceTags: string;
		Owner: string;
		DiarieNumber: number;
		ConfirmWebHooks: boolean;
	}
	export class ServiceGuyToBeGone {
		Id: string;
		Firstname: string;
		Lastname: string;
		CompanyName: string;
		Phone: string;
		Email: string;
		ContextId: string;
		InventoryItems: InventoryItemInfo[] = [];
		Assets: InventoryAssetInfo[] = [];
		LocationCheckups: LocationCheckupInfo[] = [];
	}
	export class ServiceGuyInfo {
		Id: string;
		Identifier: string;
		Firstname: string;
		Lastname: string;
		Companyname: string;
		Phone: string;
		Email: string;
		ContextId: string;
		ServiceGuyTypeId: number;
		DeliveryAddress: string;
		DeliveryZipCode: string;
		DeliveryCity: string;
		DeliveryCountry: string;
		CustomerAccount: string;
		ServiceGuyType: ServiceGuyTypeInfo | undefined;
		IsDeleted: boolean;
		InventoryItems: InventoryItemInfo[] = [];
		Assets: InventoryAssetInfo[] = [];
		AssignedLocationsCount: number;
		AssignedLocations: LocationInfo[] | undefined;
		AssignedLocationsFirst: string;
		AssignedLocationsAll: string;
	}
	export class ServiceGuyTypeInfo {
		Id: number;
		Name: string;
		Description: string;
		CreatedAt: moment.Moment;
		DeletedAt: moment.Moment | undefined;
		StockSettings: ServiceGuyTypeStockSettingInfo[] = [];
	}
	export class ServiceGuyTypeStockSettingInfo {
		ServiceGuyTypeId: number;
		ItemId: string;
		MinLevel: number;
		RecommendedLevel: number;
		Item: ItemInfo | undefined;
		Type: ServiceGuyTypeInfo | undefined;
	}
	export class ServiceLocationInfo {
		Id: number;
		Longitude: number | undefined;
		Latitude: number | undefined;
		Phone: string;
		ZipCode: string;
		City: string;
		Name: string;
		public toString(): string { return this.Name; } 
		Address: string;
		LocationCode: string;
		Distance: number;
		IsPrefered: boolean;
		Email: string;
		ToString: string;
	}
	export class ServicePartnerAssignedLocationInfo {
		Location: LocationInfo | undefined;
		LastCheckupDone: moment.Moment | undefined;
		IsServicePartner: boolean;
		IsLocalServicePartner: boolean;
		Damages: DamageInfo[] = [];
		DamagesCount: number;
	}
	export class ServicePartnerOverviewInfo {
		ServiceGuy: ServiceGuyInfo | undefined;
		ServicePartner: ServiceLocationInfo | undefined;
		AssignedLocations: ServicePartnerAssignedLocationInfo[] = [];
		AssignedLocationsCount: number;
		DamagesCount: number;
		LastCheckedLocationId: number | undefined;
		LastCheckedLocationName: string;
		LastCheckupDone: moment.Moment | undefined;
	}
	export class ServiceRequestDetails {
		Id: string;
		RequestNo: number;
		RentalObjectId: number;
		RegistrationNUmber: string;
		ServiceLocationId: number | undefined;
		ServiceLocationCode: string;
		RentalLocationId: number | undefined;
		RentalLocationCode: string;
		CreatedAt: moment.Moment;
		Description: string;
		Status: ServiceRequestStatus | undefined;
		ExpectedResolveDate: moment.Moment | undefined;
		ActualResolveDate: moment.Moment | undefined;
		Tags: String[] | undefined;
		IncidentDate: moment.Moment | undefined;
		ImageIds: string;
		ContactFirstName: string;
		ContactLastName: string;
		ContactEmail: string;
		ContactPhone: string;
		RecordNumber: string;
		IsInsurance: boolean;
		IsOneWay: boolean;
		LFInvoiced: boolean;
		LFInvoicedDate: moment.Moment | undefined;
		SparePartsCost: number | undefined;
		SparePartsDiscount: number | undefined;
		TransportCost: number | undefined;
		LaborCost: number | undefined;
		SelfRisk: number | undefined;
		InvoiceLF: boolean;
		SalesPrice: number | undefined;
		InsuranceId: number | undefined;
		IsRepurchased: boolean;
		RequestEventDetails: RequestEventDetails[] = [];
		RequestImages: T4File[] | undefined;
	}
	export class ServiceRequestUpdateDetails {
		Head: ServiceRequestUpdateHeader | undefined;
		Rows: ServiceRequestUpdateRow[] = [];
	}
	export class ServiceRequestUpdateHeader {
		CustomerNumber: string;
		CaseNumber: string;
		Store: number;
		Date: string;
		ContactName: string;
	}
	export class ServiceRequestUpdateRow {
		Text: string;
		ArticleNumber: string;
		Description: string;
		Amount: number;
		Price: number;
	}
	export class SubscriptionInfo {
		Id: string;
		ContextId: string;
		ProductId: string;
		StartDate: moment.Moment;
		EndDate: moment.Moment | undefined;
		LastInvoiceDate: moment.Moment | undefined;
		InvoiceCount: number;
		InvoiceSum: number;
		CreatedAt: moment.Moment;
		CreatedBy: string;
		DeletedAt: moment.Moment | undefined;
		DeletedBy: string;
		Product: ProductInfo | undefined;
	}
	export class UsedPartInfo {
		Id: string;
		RequestId: number;
		RentalObjectId: number;
		ItemId: string;
		ItemDescription: string;
		CreatedAt: moment.Moment;
		Amount: number;
		Price: number;
		ServiceRequest: RequestDetails | undefined;
	}
	export class BookingAlternative {
		RentalLocation: LocationInfo | undefined;
		PickupLocationId: number;
		ObjectTypeId: number;
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		Period: Date;
		Distance: number;
		ObjectId: number;
	}
	export class BookingResult {
		OfferSent: boolean;
		PickupResultCode: PickupResultCode | undefined;
		ReturnResultCode: ReturnResultCode | undefined;
	}
	export class ReturnValidation {
		Result: ReturnValidationResult | undefined;
		ReturnPrice: PriceModel | undefined;
		Action: ReturnResultAction | undefined;
		ReceiptExists: boolean;
	}
	export class CompanyInfo {
		Id: number;
		OrgNo: string;
		Name: string;
		Address: string;
		Street: string;
		ZipCode: string;
		City: string;
		Co: any;
		Country: any;
		AllowInvoicing: boolean;
		InvoiceCode: string;
		CustomerNumber: string;
	}
	export class CostInfo {
		Type: CostType | undefined;
		TimeStamp: moment.Moment;
		IsCanceled: boolean;
		Amount: number;
		Id: number;
		CanceledAt: moment.Moment | undefined;
		Description: string;
		ArticleName: string;
		IsPaid: boolean;
		IsRefunded: boolean;
		PaymentId: number | undefined;
		RentalId: number;
	}
	export class CreateBookingModel {
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		PickupLocationId: number;
		ReturnLocationId: number;
		DiscountId: string;
		Notes: string;
		IsOneWay: boolean;
		Addons: number[];
		CustomerObject: CustomerInfo | undefined;
		CustomerId: number | undefined;
		RentalObjectTypeId: number | undefined;
		ObjectId: number | undefined;
		WebBooking: boolean | undefined;
		BookingLatitude: number | undefined;
		BookingLongitude: number | undefined;
		inStoreBooking: boolean | undefined;
		InvoiceCode: string;
		InvoiceAccount: string;
		InvoiceCustomerId: number | undefined;
		MetaData: string;
		PickupDevice: string;
		ReturnDevice: string;
		TravelRange: NuwielTravelRange | undefined;
		UseCurrentContext: boolean;
	}
	export class CustomerInfoConverter {
		CanWrite: boolean;
		CanRead: boolean;
	}
	export class CustomerInfo {
		SSN: string;
		Firstname: string;
		Lastname: string;
		CompanyName: string;
		Address: string;
		Street: string;
		ZipCode: string;
		City: string;
		Phone: string;
		MobilePhone: string;
		Email: string;
		OrgNo: string;
		Id: number | undefined;
		Type: CustomerType | undefined;
		Payment: CustomerPaymentRules | undefined;
		Blocked: boolean;
		BlockedReason: string;
		Notes: string;
		UserId: string;
		HasDibsTicket: boolean;
		ReceivingAdvertising: boolean;
		AllowInvoicing: boolean;
		InvoiceCode: string;
		CustomerNumber: string;
		InvoiceCustomerName: string;
		UserKey: string;
		Fields: any = {};
	}
	export class CustomerInfoExtensions {
	}
	export enum MaskValueType2 {
		General = 0,
		Address = 1,
		Email = 2,
		Zip = 3,
	}
	export class StringExtensions {
	}
	export class DailySalesItem {
		Date: moment.Moment;
		RentalId: number;
		PaymentReference: string;
		Amount: number;
		VAT: number;
		Total: number;
	}
	export class DiscountReasonInfo {
		Id: string;
		Reason: string;
	}
	export class FindNearByOptionsResult {
		AvailableNextSlot: moment.Moment | undefined;
		NearByLocations: LocationInfo[] = [];
		OtherCategoryObjectTypes: ObjectTypeInfo[] = [];
	}
	export class FindSlotsQuery {
		From: moment.Moment;
		To: moment.Moment;
		Locations: number[] = [];
	}
	export class FindSlotsResults {
		LocationId: number;
		TypeId: number;
		TimeSlots: TimeSlot[] = [];
	}
	export class TimeSlot {
		SlotNo: number;
		Date: moment.Moment;
		From: moment.Moment;
		To: moment.Moment;
	}
	export class InvoicePayment {
		CustomerReference: string;
		PaymentReference: string;
		PaymentDate: moment.Moment;
		Amount: number;
		Vat: number;
		TotalAmount: number;
		Costs: CostInfo[] = [];
		RentalId: number;
	}
	export class LocationKpi {
		Turnover: number;
		Prognosis: number;
		Rentals: number;
		Utilization: number;
	}
	export class NokeResponse {
		result: string;
		error_code: number;
		message: string;
		request: string;
		success: boolean;
	}
	export class ObjectTypeInfo {
		FreeText: string;
		CheckCondition: string;
		IsDefault: boolean;
		IsSelected: boolean;
		ReplacementFor: string;
		AskIfNotSelected: boolean;
		Category: string;
		CategoryIndex: number;
		IsHidden: boolean;
		ContextId: string | undefined;
		OverridesType: string;
		ExcludeFromCalculation: boolean;
		UnlimitedAvailability: boolean;
		UnlimitedRelations: boolean;
		AdditiveTo: Additive[] = [];
		VATPercentage: number;
		SortOrder: number;
		IsInsurance: boolean;
		LocationId: number | undefined;
		GroupId: number | undefined;
		IsRefundable: boolean;
		ObjectCount: number;
		ArticleNo: string;
		TypeClassId: number | undefined;
		IncludeCostInRentReceiptLine: boolean;
		PictureUri: string;
		TotalWeight: string;
		MaxLoad: string;
		Length: string;
		Width: string;
		Height: string;
		SpecialCondition: boolean;
		Attributes: RentalObjectTypeAttributes[] = [];
		Id: number;
		Alias: string;
		Title: string;
		Description: string;
	}
	export class Additive {
		Id: string;
		MainObjectId: number;
	}
	export class RentalObjectTypeAttributes {
		AttributeId: number;
		Key: string;
		Name: string;
		Unit: string;
		Shorthand: string;
		Value: string;
	}
	export class ObjectTypeInfoAddOn {
		IsDefault: boolean;
		IsSelected: boolean;
		AskIfNotSelected: boolean;
		IsHidden: boolean;
		Id: number;
		Alias: string;
		Title: string;
		Description: string;
	}
	export class ObjectTypeInfoBase {
		Id: number;
		Alias: string;
		Title: string;
		Description: string;
	}
	export class ObjectTypeInfoSlim {
		PictureUri: string;
		TotalWeight: string;
		MaxLoad: string;
		Length: string;
		Width: string;
		Height: string;
		SpecialCondition: boolean;
		Attributes: RentalObjectTypeAttributes[] = [];
		Id: number;
		Alias: string;
		Title: string;
		Description: string;
	}
	export class OneWayAvailability {
		LocationId: number;
		LocationName: string;
		Distance: number;
		Small: number;
		Medium: number;
		Large: number;
		XL: number;
		IncomingSmall: number;
		IncomingMedium: number;
		IncomingLarge: number;
		IncomingXL: number;
	}
	export class PaymentInfo {
		Id: number;
		Amount: number;
		IsExtension: boolean | undefined;
		Reference: string;
		Methods: string;
		TimeStamp: moment.Moment;
		Refunded: number | undefined;
		IsRefund: boolean;
		RefundFailed: boolean;
	}
	export class PhotoAngleInfo {
		Id: number;
		Name: string;
		Icon: string;
		ImageUri: string;
		Description: string;
		DefaultType: boolean;
		ContextId: string;
		TypeClassId: number;
		Key: string;
	}
	export class PickupModel {
		RentalId: number;
		BypassCardPayment: boolean;
		Predisclose: boolean;
		PickupDevice: string;
	}
	export enum AlternativType {
		Best = 0,
		Cheapest = 1,
		Other = 2,
		Perfect = 3,
	}
	export class RentalAlternative {
		Id: number;
		PickupLocationId: number;
		ReturnLocationId: number | undefined;
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		ObjectTypeId: number;
		Price: PriceModel | undefined;
		Type: AlternativType | undefined;
		HasPickupLocationChanged: boolean;
		HasPickupTimeChanged: boolean;
		HasReturnLocationChanged: boolean;
		HasReturnTimeChanged: boolean;
		HasObjectTypeChanged: boolean;
		IsPreliminary: boolean;
		LocationDiff: number;
		QueueIndex: number | undefined;
		AverageMinAvailability: number;
		AverageMaxAvailability: number;
		PredictedBindDate: moment.Moment | undefined;
	}
	export class RentalEventInfo {
		Id: string;
		RentalObjectId: number | undefined;
		TimeStamp: moment.Moment;
		EventId: RentalEventType | undefined;
		Note: string;
		UserId: string;
		SignedBy: string;
		IsCSAction: boolean | undefined;
	}
	export class RentalMetaData {
		Source: string;
		Theme: string;
		Context: string;
		SubContext: string;
	}
	export class RentalObjectInfo {
		Id: number;
		Title: string;
		Alias: string;
		Image: string;
		Status: RentalObjectStatus | undefined;
		RentalLocation: LocationInfo | undefined;
		Type: ObjectTypeInfo | undefined;
		IsEnabled: boolean;
		IsDisabledByAdmin: boolean;
		NextInspectionDate: moment.Moment;
		RegistrationYear: number;
		ToString: string;
		ServiceRequests: RequestDetails[] = [];
		Movements: RentalObjectMovement[] = [];
		Category: string;
		CategoryIndex: number | undefined;
		SerialNo: string;
		ContractStartDate: moment.Moment | undefined;
		ContractEndDate: any;
		AvailableOnline: boolean;
		IsDeleted: boolean;
		IsDeletionConfirmed: boolean;
		Notes: NoteInfo[] = [];
		LockIds: string[] = [];
		LockId: string;
		IsManual: boolean;
		Locks: SmartLockInfo[] = [];
		Lock: SmartLockInfo | undefined;
		HasNotes: boolean;
		HasIssues: boolean;
		IsBrenderupTrailer: boolean;
		ActionExpire: moment.Moment | undefined;
		IsRecalled: boolean | undefined;
		RecalledActionTaken: boolean | undefined;
		RecalledActionAt: moment.Moment | undefined;
		RecalledActionBy: string;
		IsSelfServiceEnabled: boolean;
		ShowInUse4Free: boolean;
	}
	export class RentalObjectMovement {
		Type: string;
		BookingId: number | undefined;
		Status: number | undefined;
		StartTime: moment.Moment;
		EndTime: moment.Moment | undefined;
		CanceledAt: moment.Moment | undefined;
		FromLocation: string;
		ToLocation: string;
	}
	export class RentalReceipt {
		RentalId: number;
		ReceiptUri: string;
	}
	export enum PickupResultCode {
		SuccessWithoutPayment = 0,
		InvalidRental = 1,
		NoLock = 2,
		PaymentFailed = 3,
		PaymentActionRequired = 4,
		SuccessWithPayment = 5,
		ObjectNotAvilable = 6,
		NotWithinTimeLimit = 7,
		NoRentalFound = 8,
		NoRentalObjectFound = 9,
		WrongStatus = 10,
		InvoicePayment = 11,
	}
	export enum ReturnResultCode {
		Success = 0,
		InvalidRental = 1,
		NoLock = 2,
		PaymentFailed = 3,
		PaymentActionRequired = 4,
		TrailerNotAtLocation = 5,
		LockOpen = 6,
		NotAtLocation = 7,
		NoRentalFound = 8,
		WrongStatus = 10,
		InvoicePayment = 11,
	}
	export enum ProlongRentalResult {
		Success = 0,
		InvalidRental = 1,
		NoLock = 2,
		Unavailable = 3,
	}
	export class ExtendRentalOption {
		Hours: number;
		EndTime: moment.Moment;
		Cost: number;
	}
	export class ReturnModel {
		RentalId: number;
		ReturnTime: moment.Moment;
		ReturnLocationId: number;
		ReceiptAction: ReturnResultAction | undefined;
		Addons: number[];
		ExtraReason: string;
		BypassCardPayment: boolean;
		Flagged: boolean;
		ReturnDevice: string;
	}
	export enum SmartLockCondition {
		Repairable = 0,
		Working = 1,
		Broken = -1,
	}
	export enum AssetCondition {
		Repairable = 0,
		Working = 1,
		Broken = -1,
	}
	export class SmartLockInfo {
		BatteryLevel: number;
		IsClosed: boolean;
		IsLocked: boolean;
		Latitude: number | undefined;
		Longitude: number | undefined;
		AtStation: boolean;
		IsOnline: boolean;
		Id: string;
		Mac: string;
		UpdatedAt: moment.Moment;
		CurrentHolder: string;
		Condition: SmartLockCondition | undefined;
		Type: string;
		LastUpdate: moment.Moment;
		IccId: string;
		BluetoothMAC: string;
		DeviceType: DeviceType | undefined;
		Password: string;
		ValidTill: moment.Moment | undefined;
		OnActiveBooking: boolean;
		SerialNo: string;
		PowerState: NuwielPowerState | undefined;
		ParkBrake: NuwielParkBrake | undefined;
		EtrailerMode: NuwielTrailerMode | undefined;
		EtrailerError: NuwielTrailerError | undefined;
	}
	export class SmartLockHistoryInfo {
		LockId: string;
		TimeStamp: moment.Moment;
		Latitude: number | undefined;
		Longitude: number | undefined;
		IsClosed: boolean;
		IsLocked: boolean;
		BatteryLevel: number;
		Created: moment.Moment;
		Reason: string;
		Speed: number;
		Altitude: number;
		Dout1: boolean | undefined;
		Dout2: boolean | undefined;
		Dout3: boolean | undefined;
		AtStation: boolean;
		OnActiveBooking: boolean;
		PowerState: NuwielPowerState | undefined;
		ParkBrake: NuwielParkBrake | undefined;
		EtrailerMode: NuwielTrailerMode | undefined;
		EtrailerError: NuwielTrailerError | undefined;
	}
	export class AssetInfo {
		Id: string;
		SerialId: string;
		Mac: string;
		CurrentHolder: string;
		Condition: AssetCondition | undefined;
		IsRetired: boolean;
		Scrapped: boolean;
		CurrentPosition: string;
		PositionTime: moment.Moment;
		Status: string;
		LastUpdated: moment.Moment | undefined;
		LocationStatus: AssetLocationStatus | undefined;
		CreatedBy: string | undefined;
		ClosedBy: string | undefined;
		ContextId: string;
		Product: ProductInfo | undefined;
		SerialNo: string;
		AssetTransactions: AssetTransactionInfo[] = [];
	}
	export class AssetsAndHolder {
		Holder: AssetHolder | undefined;
		Assets: AssetAndLock[] = [];
		Asset: AssetAndLock | undefined;
		Index: number;
	}
	export class AssetAndLock {
		Lock: SmartLockInfo | undefined;
		Asset: AssetInfo | undefined;
	}
	export class AssetHolder {
		DisplayName: string;
		Username: string;
		RentalObject: RentalObjectInfo | undefined;
		Location: LocationInfo | undefined;
	}
	export class PickupResult {
		Code: PickupResultCode | undefined;
		PaymentResult: string;
		PaymentResultCode: string;
		IsSuccess: boolean;
	}
	export class ReturnResult {
		Code: ReturnResultCode | undefined;
		PaymentResult: string;
		PaymentResultCode: string;
		IsSuccess: boolean;
	}
	export class SwapTrailerResults {
		Success: boolean;
		NewRegNo: string;
		AlternativeTypes: ObjectTypeInfo[] = [];
	}
	export class TypeCategoryInfo {
		Id: string;
		Name: string;
		Description: string;
		SortOrder: number;
		ContextId: string;
		Content: ObjectTypeInfo[] = [];
		ImageUri: string;
		Countries: string[] = [];
		IsConcept: boolean;
	}
	export class UserSignInResult {
		Success: boolean;
		ErrorCode: SignInError | undefined;
	}
	export class UserValidationResult {
		Validated: boolean;
		UserId: string;
		IsNew: boolean;
	}
	export class IntervalPrice {
		Period: number;
		Price: number;
	}
	export class SparepartPriceModel {
		SparepartId: number;
		SparePartType: ServiceRequestTags | undefined;
		Price: number;
	}
	export class PaymentRequestInfo {
		Id: number;
		Phone: string;
		Email: string;
		Description: string;
		Status: PaymentRequestStatus | undefined;
		Amount: number;
		TimeStamp: moment.Moment;
		ExpiresAt: moment.Moment;
		CanceledAt: moment.Moment | undefined;
		CanceledBy: string;
		CompletedAt: moment.Moment | undefined;
		Rental: RentalInfo | undefined;
		RentalId: number;
		Payment: PaymentInfo | undefined;
		CreatedBy: string;
	}
	export class Invoice {
		InvoiceDate: moment.Moment | undefined;
		Amount: number;
		Provision: number;
	}
	export class InvoiceSpecification {
		Header: Invoice | undefined;
		Lines: InvoiceLine[] = [];
	}
	export class InvoiceLine {
		RentalId: number;
		From: string;
		To: string;
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
		ActualReturnTime: moment.Moment | undefined;
		CustomerPayment: number;
		InvoicedInsurancePayment: number | undefined;
		InvoicedCustomerPayment: number | undefined;
		BookingProvision: number | undefined;
		DiscloseProvision: number | undefined;
		ReturnProvision: number | undefined;
		InsuranceProvision: number | undefined;
		Size: string;
		Amount: number;
		Provision: number;
		IsWebBooking: boolean;
		PaymentReference: string;
		PaymentTimestamp: moment.Moment;
	}
	export class LocationOverview {
		WeekId: number;
		BookingTypes: OneWayObjectTypes | undefined;
		ObjectTypes: OneWayObjectTypes | undefined;
		LocationId: number;
		BookingCount: number;
		UnboundBookingCount: number;
		ObjectCount: number;
		AvailableObjectCount: number;
		ConfirmableObjectCount: number;
		DisabledCount: number;
		LocationInfo: LocationInfo | undefined;
		WarningActivated: boolean;
	}
	export class LockPosition {
		ObjectId: number;
		Object: RentalObjectInfo | undefined;
		LockId: string;
		Lat: number;
		Lng: number;
		AtStation: boolean;
		LastUpdate: moment.Moment;
	}
	export class OneWayCountingInfo {
		Id: string;
		StartDate: moment.Moment;
		EndDate: moment.Moment;
		CreatedAt: moment.Moment;
		CreatedBy: string;
		LocationCount: number;
		CompletedLocationCount: number;
		Completion: number;
		CountingLocations: OneWayCountingLocationInfo[] = [];
	}
	export class OneWayCountingLocationInfo {
		Id: string;
		LocationId: number;
		CompletedAt: moment.Moment | undefined;
		CompletedBy: string;
		Location: LocationInfo | undefined;
		IsCompleted: boolean;
		Results: OneWayCountingResultInfo[] = [];
	}
	export class OneWayCountingResultInfo {
		Id: string;
		RentalObjectId: number;
		Result: OneWayCountingResult | undefined;
		HandledAt: moment.Moment | undefined;
		HandledBy: string;
		IsHandled: boolean;
		RentalObject: RentalObjectInfo | undefined;
		SystemLocation: LocationInfo | undefined;
		CountingLocation: LocationInfo | undefined;
	}
	export class OneWayCountingForAllLocationsInfo {
		LocationId: number;
		Location: LocationInfo | undefined;
		StartDate: moment.Moment;
		EndDate: moment.Moment;
		CompletedAt: moment.Moment | undefined;
	}
	export class RentalObjectPosition {
		BookingId: number | undefined;
		FromTime: moment.Moment | undefined;
		Id: number;
		FromWeekId: number | undefined;
		IsAvailable: boolean | undefined;
		Probability: TrailerPositionProbability | undefined;
		RentalLocationId: number;
		RentalObjectTypeId: number | undefined;
		ToTime: moment.Moment | undefined;
		Title: string;
		Alias: string;
		ToWeekId: number | undefined;
		RealFromTime: moment.Moment;
		IsConfirmed: boolean;
		InboundBookingId: number | undefined;
		InboundCustomerId: number | undefined;
		InboundCustomerName: string;
	}
	export class TireChangeInfo {
		Id: number;
		RentalObjectId: number;
		RentalObject: RentalObjectInfo | undefined;
		LocationId: number;
		Location: LocationInfo | undefined;
		Amount: number;
		Invoiced: boolean | undefined;
		InvoicedAt: moment.Moment | undefined;
		CreatedBy: string;
		CreatedAt: moment.Moment;
		UpdatedBy: string;
		UpdatedAt: moment.Moment | undefined;
		IsDeleted: boolean | undefined;
	}
	export class ConnectLockToObjectInfo {
		IsInvalidLock: boolean;
		IsInvalidTracker: boolean;
		IsSuccess: boolean;
		LockInUse: boolean;
		UsedTrailer: string;
	}
	export class DisableObjectResult {
		IsSuccessful: boolean;
		MovedBookings: number;
		AffectedBookings: number;
	}
	export class FindTypesQuery {
		From: moment.Moment;
		To: moment.Moment;
		Locations: number[] = [];
	}
	export class FindTypesResults {
		LocationId: number;
		Types: ObjectTypeInfo[] = [];
	}
	export class NoteInfo {
		Id: number;
		Content: string;
		Action: string;
		CreatedAt: moment.Moment;
		CreatedBy: string;
		DeletedAt: moment.Moment | undefined;
		DeletedBy: string;
	}
	export class ObjectImportData {
		TrailerId: number;
		ExternalId: string;
		Alias: string;
		RegNo: string;
		TypeId: number;
		StationId: number;
		CostPerMonth: number;
		IsDeleted: boolean;
		SerialNo: string;
		ContractStartDate: moment.Moment | undefined;
		ContractEndDate: moment.Moment | undefined;
		Service: boolean;
		NextInspectionDate: moment.Moment;
	}
	export class RentalObjectWithLockInfo {
		Id: number;
		Name: string;
		Alias: string;
		RentalLocationGroupId: number;
		RentalObjectTypeId: number;
		LocationName: string;
		LocationId: number;
		Concept: string;
		GroupHierarchy: string;
		GpsLock: SmartLockInfo | undefined;
	}
	export class UpdateObjectResults {
		Success: boolean;
		ValidationStatus: ObjectValidationStatus | undefined;
		Id: number | undefined;
	}
	export class DirectQueuedMessageInfo {
		UserId: string;
		RentalId: number | undefined;
		ReceiverPhone: string;
		ReceiverEmail: string;
		Category: QueuedMessageCategory | undefined;
		Method: QueuedMessageMethod | undefined;
		Priority: QueuedMessagePriority | undefined;
		Title: string;
		Message: string;
		ActionText: string;
		ActionLink: string;
		DelayPeriodInMinutes: number;
		FallbackMethod: QueuedMessageMethod | undefined;
	}
	export class PushNotificationMessage {
		InstallationId: string;
		FcmToken: string;
		Platform: UserDevicePlatform | undefined;
		Title: string;
		Content: string;
		NotificationId: string;
		UserId: string;
		RentalId: number | undefined;
		MessageType: string;
		SecondaryIdentifier: string;
	}
	export class PushNotificationResult {
		Success: boolean;
		MessageId: string;
		ErrorCode: string;
		ErrorMessage: string;
		InvalidRegistration: boolean;
	}
	export class QueuedMessageAudienceConditionInfo {
		Id: string | undefined;
		ConditionGroup: QueuedMessageConditionGroup | undefined;
		Field: QueuedMessageConditionField | undefined;
		Operator: QueuedMessageConditionOperator | undefined;
		Value: string;
		Value2: string;
		DisplayValue: string;
	}
	export class QueuedMessageInfo {
		Id: string;
		QueuedMessageSettingId: string | undefined;
		QueuedMessageSetting: QueuedMessageSettingInfo | undefined;
		ContextId: string | undefined;
		UserId: string;
		RentalId: number | undefined;
		ReceiverPhone: string;
		ReceiverEmail: string;
		Category: QueuedMessageCategory | undefined;
		Method: QueuedMessageMethod | undefined;
		Priority: QueuedMessagePriority | undefined;
		Subject: string;
		Body: string;
		ActionText: string;
		ActionLink: string;
		OccurrenceNumber: number;
		IsProcessed: boolean;
		IsCancelled: boolean;
		CreatedAt: moment.Moment;
		ProcessedAt: moment.Moment | undefined;
		CancelledAt: moment.Moment | undefined;
		CancelReason: number | undefined;
		SentTo: string;
		SentViaContext: string | undefined;
		DelayedUntil: moment.Moment | undefined;
		RetryCount: number;
		NextAttemptAt: moment.Moment | undefined;
		LastAttemptAt: moment.Moment | undefined;
		LastError: string;
		FallbackSent: boolean;
		FallbackSentAt: moment.Moment | undefined;
		FallbackMethod: QueuedMessageMethod | undefined;
	}
	export class QueuedMessageSettingInfo {
		Id: string | undefined;
		ContextId: string | undefined;
		Name: string;
		Category: QueuedMessageCategory | undefined;
		Method: QueuedMessageMethod | undefined;
		Priority: QueuedMessagePriority | undefined;
		IsActive: boolean;
		Title: string;
		Message: string;
		ActionText: string;
		ActionLink: string;
		DelayPeriodInMinutes: number;
		MaximumSendCount: number;
		RepeatIntervalInMinutes: number | undefined;
		UseFallback: boolean;
		FallbackMethod: QueuedMessageMethod | undefined;
		SendFallbackImmediatelyOnFailure: boolean;
		StartDate: moment.Moment | undefined;
		EndDate: moment.Moment | undefined;
		IsOneTime: boolean;
		ScheduledAt: moment.Moment | undefined;
		OneTimeQueuedAt: moment.Moment | undefined;
		Conditions: QueuedMessageAudienceConditionInfo[] = [];
	}
	export class NokeLockInfoResponse {
		Result: string;
		Message: string;
		ErrorCode: number;
		Data: NokeLockInfoResultWrapper | undefined;
	}
	export class NokeLockInfoResultWrapper {
		Locks: NokeLockInfoResult[] = [];
	}
	export class NokeLockInfoResult {
		LockId: string;
		Mac: string;
		BatteryLevel: number;
		FirmwareVersion: string;
	}
	export class NokeUnlockResponse {
		Result: string;
		Message: string;
		ErrorCode: number;
		Data: NokeUnlockCommand | undefined;
	}
	export class NokeUnlockCommand {
		Commands: string;
	}
	export class ConceptModel {
		ContextId: string;
		DefiningConcept: string;
		SGTypeName: string;
		SGTypeDescription: string;
	}
	export class MessageModel {
		Id: string;
		Priority: MessagePriority | undefined;
		From: string;
		Headline: string;
		Content: string;
		IsUnread: boolean;
		SentAt: moment.Moment;
		ValidFrom: moment.Moment | undefined;
		ValidThrough: moment.Moment | undefined;
		RequireReadConfirmation: boolean;
		Reads: MessageReadModel[] = [];
	}
	export class MessageReadModel {
		Id: string;
		MessageId: string;
		Username: string;
		LocationId: number | undefined;
		Response: string;
		OpenedAt: moment.Moment;
		RespondedAt: moment.Moment | undefined;
		LocationName: string;
	}
	export class Receiver {
		Type: ReceiverType | undefined;
		ReceiverId: string;
		FriendlyName: string;
		Description: string;
		AddAsDefault: boolean;
		LocationId: number | undefined;
		GroupId: number | undefined;
	}
	export enum ReceiverType {
		User = 0,
		Location = 1,
		Group = 2,
		SendGroup = 3,
		Email = 4,
	}
	export class MapPoint {
		Lat: number;
		Lng: number;
		Description: string;
	}
	export class EntityAttachmentInfo {
		Id: string;
		EntityId: string;
		CreatedAt: moment.Moment;
		SentTo: string;
		Subject: string;
		Content: string;
		ContentType: EntityAttachmentType | undefined;
		EntityEvent: EntityEventInfo | undefined;
	}
	export enum EntityAttachmentType {
		Text = 0,
		Html = 1,
	}
	export class EntityEventInfo {
		Id: string;
		EntityId: string;
		EntityTypeId: string;
		CreatedAt: moment.Moment;
		EventId: number;
		Notes: string;
		Metadata: string;
		UserId: string;
		SignedBy: string;
		EntityType: EntityTypeInfo | undefined;
		EventType: string;
		RentalObjectId: number | undefined;
		IsCSAction: boolean | undefined;
		AttachmentExists: boolean;
		EntityAttachmentInfos: EntityAttachmentInfo[] = [];
	}
	export class EntityTypeInfo {
		Id: string;
		Name: string;
		Description: string;
	}
	export class ShipmentInfo {
		Id: string;
		UserId: string;
		CreatedAt: moment.Moment;
		StartedAt: moment.Moment | undefined;
		CompletedAt: moment.Moment | undefined;
		Status: ShipmentStatus | undefined;
		LastKnownLatitude: number | undefined;
		LastKnownLongitude: number | undefined;
		Cargo: CargoInfo[] = [];
	}
	export class CargoInfo {
		RentalObject: RentalObjectInfo | undefined;
		PickupLocation: LocationInfo | undefined;
		ReturnLocation: LocationInfo | undefined;
		PickupTime: moment.Moment;
		DropTime: moment.Moment | undefined;
		IsLoaded: boolean;
		Id: string;
	}
	export class LocationImportData {
		Id: number;
		Name: string;
		Address: string;
		ZipCode: string;
		City: string;
		Country: string;
		Phone: string;
		Category: string;
		AllowOneWay: boolean;
		LocationId: string;
		Email: string;
		InvoiceAccount: string;
		SalesRep: string;
		ServicePartnerId: number | undefined;
		RepairPartnerId: number | undefined;
		RepairZone: number | undefined;
		GroupId: number;
		CustomerLocationId: string;
	}
	export class LocationInfo {
		RentalLocationGroupId: number;
		Distance: number | undefined;
		LocationId: number;
		LocationCode: string;
		CustomerLocationId: string;
		ServiceLocationId: number | undefined;
		LocalServiceLocationId: number | undefined;
		ServiceZone: number | undefined;
		ServiceLocation: ServiceLocationInfo | undefined;
		LocalServiceLocation: ServiceLocationInfo | undefined;
		IsServiceLocation: boolean;
		Hierarchy: string;
		ToString: string;
		HardTrailerLimit: number;
		SoftTrailerLimit: number;
		ServiceAgreement: boolean;
		IsOneWay: boolean;
		InvoiceAccount: string;
		IsDeleted: boolean;
		SalesRep: SalesRepInfo | undefined;
		TrailerPointLatitude: number;
		TrailerPointLongitude: number;
		TrailerPointRadius: number;
		ServiceGuyId: string | undefined;
		ContextId: string;
		ExternalBookingUri: string;
		GoogleReviewUri: string;
		EnableOWSelfService: boolean;
		IsUnmanned: boolean;
		UseNewOWCalculation: boolean | undefined;
		RentalObjects: CurrentObjectStatusInfo[] = [];
		Phone: string;
		ZipCode: string;
		City: string;
		Country: string;
		Name: string;
		Address: string;
		OpenHours: string;
		Email: string;
		OpenForPickup: boolean;
		OpenForReturn: boolean;
		ClosedReason: string;
		HasFamilies: string;
		Id: number;
		Longitude: number;
		Latitude: number;
	}
	export class LocationInfoBase {
		Id: number;
		Longitude: number;
		Latitude: number;
		Name: string;
	}
	export class LocationInfoSlim {
		Phone: string;
		ZipCode: string;
		City: string;
		Country: string;
		Name: string;
		Address: string;
		OpenHours: string;
		Email: string;
		OpenForPickup: boolean;
		OpenForReturn: boolean;
		ClosedReason: string;
		ExternalBookingUri: string;
		HasFamilies: string;
		Id: number;
		Longitude: number;
		Latitude: number;
	}
	export class LocationUserInfo {
		Id: number;
		Firstname: string;
		Lastname: string;
		Phone: string;
		Email: string;
		PinCode: string;
	}
	export class OpenHours {
		Date: moment.Moment;
		IsClosed: boolean;
		Opens: moment.Moment;
		Closes: moment.Moment;
	}
	export class OpenHourSetting {
		Id: number;
		DayOfWeek: number | undefined;
		SpecificDate: moment.Moment | undefined;
		Opens: moment.Moment;
		Closes: moment.Moment;
		Closed: boolean;
	}
	export class SalesRepInfo {
		Image: string;
		Username: string;
		Firstname: string;
		Lastname: string;
		Phone: string;
		Email: string;
	}
	export class UpdateLocationResults {
		Success: boolean;
		ValidationStatus: LocationValidationStatus | undefined;
		Id: number | undefined;
	}
	export class TurboHubEvent {
		Type: TurboHubEventType | undefined;
		ContextId: string;
		Timestamp: moment.Moment;
		Entity: any;
		EntityId: string;
		ClientId: string;
	}
	export class HierarchyObject {
		ID: string;
		Name: string;
		GroupId: number | undefined;
		Children: HierarchyObject[] = [];
		ImageUrl: string;
	}
	export class ExtractRegNoResponse {
		RegNo: string;
		Success: boolean;
		Error: string;
	}
	export class T4Image {
		EntityId: string;
		ContextId: string;
		Type: ImageType | undefined;
		Uri: string;
		Data: string;
	}
	export class T4File {
		ContextId: string;
		Type: FileType | undefined;
		Filename: string;
		Uri: string;
		Data: string;
	}
	export class T4ListItem {
		Id: string;
		Name: string;
		ContextId: string;
	}
	export class T4Result {
		IsSuccess: boolean;
		StatusCode: number;
		Message: string;
		Data: any;
	}
	export class TranslationField {
		Language: string;
		Key: string;
		Value: string;
		Comment: string;
		IsVerified: boolean;
	}
	export class TranslationInfo {
		Id: string;
		Key: string;
		CreatedAt: moment.Moment;
		TranslationFields: TranslationField[] = [];
		AllTranslations: string;
		Comment: string;
	}
	export class CustomerContextSettings {
		Fields: CustomerField[] = [];
	}
	export enum CustomerFieldType {
		Text = 0,
	}
	export class CustomerField {
		FieldId: string;
		Type: CustomerFieldType | undefined;
		Mapping: string;
		Visible: boolean;
		DefaultValue: string;
		Required: boolean;
		MinLength: number;
		MaxLength: number;
		RegEx: string;
		CopyFrom: string;
		Placeholder: string;
		Value: string;
		Columns: number;
		Label: string;
		ValidFor: CustomerType | undefined;
		IsValid: boolean;
	}
	export class ContextInfo {
		Id: string;
		Name: string;
		LocationDate: moment.Moment;
	}
	export class ProductPriceInfo {
		Id: string;
		ContextId: string;
		ProductId: string;
		Price: number;
		Type: ProductPriceType | undefined;
		UseAbsoluteAmount: boolean;
		Product: ProductInfo | undefined;
	}
	export class ProductInfo {
		Id: string;
		ItemId: string;
		Name: string;
		Unit: string;
		AxItemId: string;
		VatPercentage: number;
		RequireSigning: boolean;
		ModelNo: string;
		InvoiceSettings: ProductInvoiceSettings | undefined;
		DeviceType: DeviceType | undefined;
	}
	export class T4InvoiceInfo {
		Id: string;
		InvoiceAccount: string;
		GeneratedAt: moment.Moment;
		CompletedAt: moment.Moment | undefined;
		MessageId: string;
		SalesId: string;
		LineCount: number;
		InvoiceAmount: number;
		VatAmount: number;
		Specification: string;
		IsProcessing: boolean;
		AggregatedLines: T4InvoiceLine[] = [];
		SentAt: moment.Moment | undefined;
		CustomerName: string;
		CustomerNumber: string;
		RequireSigning: boolean;
		Flow: string;
		InvoiceProductList: string[] = [];
		InvoiceDocuments: T4InvoiceDocumentsInfo[] = [];
	}
	export class T4InvoiceLine {
		ProductId: string;
		ProductName: string;
		Count: number;
		Price: number;
		ItemId: string;
		Credit: boolean;
		CreditAmount: number;
		CreditedAmount: number;
	}
	export class T4InvoiceDocumentsInfo {
		Name: string;
		Uri: string;
	}
	export class CampaignInfo {
		DiscountCode: string;
		CreatedAt: moment.Moment;
		ValidFrom: moment.Moment;
		ValidThrough: moment.Moment;
		MultipleUse: boolean;
		RequireCode: boolean;
		Condition: string;
		MaxUseCount: number;
		UsageCount: number;
		IsUsed: number;
		Priority: number;
		IsValid: boolean | undefined;
		IsStackable: boolean;
		Comment: string;
		CommentIsPublic: boolean;
		ReasonId: string | undefined;
		MaxUseCountPerCustomer: number | undefined;
		ContextId: string | undefined;
		IsTemplate: boolean;
		TemplateCode: string;
		GenerationPattern: DiscountGenerationPattern | undefined;
		GenerationProvider: string;
		GenerationBatchId: string | undefined;
		ConditionText: string;
		CanEdit: boolean;
		Type: CampaignType | undefined;
		Value: number;
		ValueType: DiscountValueType | undefined;
		Trigger: Triggers | undefined;
		IsPartnerDiscount: boolean | undefined;
		Title: string;
		ExternalCode: string;
		Image: T4Image | undefined;
		ValidTo: moment.Moment | undefined;
		ActivatedAt: moment.Moment | undefined;
		LogoType: T4Image | undefined;
		Issuer: string;
		AllowDiscountOnBookingFee: boolean;
		IsInviteFriendsCampaign: boolean;
		MessageContentHeader: string;
		MessageContent: string;
		NoCompetitionCampaign: boolean;
		AppMessageTitle: string;
		AppMessageDescription: string;
		AppMenuMessageTitle: string;
		AppMenuMessageDescription: string;
		CampaignTerms: string;
		PartnerOfferType: PartnerCampaignType | undefined;
		PartnerOfferDisclaimer: string;
	}
	export class DiscountCampaignReasonInfo {
		Id: number;
		Name: number;
	}
	export class GenerateVoucherResult {
		TemplateCode: string;
		BatchId: string;
		VoucherUrl: string;
		VoucherCodes: string[] = [];
		GroupId: number;
		Partner: string;
	}
	export class AddExternalLoginBindingModel {
		ExternalAccessToken: string;
	}
	export class ChangePasswordBindingModel {
		OldPassword: string;
		NewPassword: string;
		ConfirmPassword: string;
	}
	export class RegisterBindingModel {
		Email: string;
		Password: string;
		ConfirmPassword: string;
	}
	export class RegisterExternalBindingModel {
		Email: string;
	}
	export class RemoveLoginBindingModel {
		LoginProvider: string;
		ProviderKey: string;
	}
	export class SetPasswordBindingModel {
		NewPassword: string;
		ConfirmPassword: string;
	}
	export class ExternalLoginViewModel {
		Name: string;
		Url: string;
		State: string;
	}
	export class ManageInfoViewModel {
		LocalLoginProvider: string;
		Email: string;
		Logins: UserLoginInfoViewModel[] = [];
		ExternalLoginProviders: ExternalLoginViewModel[] = [];
	}
	export class UserInfoViewModel {
		Email: string;
		HasRegistered: boolean;
		LoginProvider: string;
	}
	export class UserLoginInfoViewModel {
		LoginProvider: string;
		ProviderKey: string;
	}
	export class AppUserSignInRequest {
		Number: string;
		NewNumber: string;
		Demo: boolean;
		RecaptchaToken: string;
		UserSent: boolean;
	}
	export class AuthToken {
		userName: string;
		token_type: string;
		access_token: string;
		expires_in: number;
		expires: string;
		issued: string;
	}
	export class BIDToken {
		Token: string;
		Settings: ClientSettings | undefined;
	}
	export class PasswordResetResult {
		User: AccountCredentials | undefined;
		Admin: AccountCredentials | undefined;
		BusinessManager: AccountCredentials | undefined;
		Email: string;
		EmailStatus: number;
	}
	export class AccountCredentials {
		Username: string;
		Password: string;
	}
	export class User {
		Username: string;
		Roles: string[] = [];
		Impersonating: User | undefined;
		MayImpersonate: boolean;
		FriendlyName: string;
		Email: string;
		Phone: string;
		IsInitiated: boolean;
		IsApi: boolean;
		ContextId: string;
		Hierarchy: string;
		Rights: string[] = [];
		ServiceGuyId: string;
		Settings: ClientSettings | undefined;
		BrandName: string;
	}
	export class UserDeviceInfo {
		Id: number;
		UserId: string;
		InstallationId: string;
		FcmToken: string;
		Platform: UserDevicePlatform | undefined;
		AppVersion: string;
		IsEnabled: boolean;
		CreatedAt: moment.Moment;
		UpdatedAt: moment.Moment;
		LastSuccessfulPushAt: moment.Moment | undefined;
	}
	export class RegisterUserDeviceRequest {
		UserId: string;
		InstallationId: string;
		FcmToken: string;
		Platform: UserDevicePlatform | undefined;
		AppVersion: string;
		IsLoggedOut: boolean;
	}
	export class DiscountModel {
		DiscountId: string;
		ReasonId: string | undefined;
		VoucherUri: string;
		VoucherDocumentUri: string;
		AppliesToBookingFee: boolean;
		Title: string;
		AppMessageTitle: string;
		AppMessageDescription: string;
		MessageContentHeader: string;
		MessageContent: string;
		NoCompetitionCampaign: boolean;
		AppMenuMessageTitle: string;
		AppMenuMessageDescription: string;
		CampaignTerms: string;
		InvitedFriends: InvitedFriendInfo[] = [];
		Value: number;
		Type: DiscountValueType | undefined;
		Comment: string;
		IsEmpty: boolean;
		IsInviteFriendsCampaign: boolean;
	}
	export class DiscountModelExtentions {
	}
	export class InvitedFriendInfo {
		Name: string;
		Date: moment.Moment;
	}
	export class DiscountModelBase {
		Value: number;
		Type: DiscountValueType | undefined;
		Comment: string;
		IsEmpty: boolean;
		IsInviteFriendsCampaign: boolean;
	}
	export class PriceInfoModel {
		MinimumBookingPeriod: number;
		SelfriskCost: number;
		SelfriskReductionCost: number;
		IsSelfriskRecustionIncluded: boolean;
		OnlineBookingFee: number;
		Deposition: number;
		UsesGpsBasedBookingFee: boolean;
	}
	export class PriceModel {
		Lines: PriceModelRow[] = [];
		Deposition: number;
		RentalPrice: number;
		DelayPenalty: number;
		BookingFee: number;
		TotalPrice: number;
		Discount: number;
		Vat: number;
		DiscountableTotalPrice: number;
		NoDiscountablePrice: number;
		DiscountableAdditions: number;
		NoDiscountAdditions: number;
		NoDiscountAddedVAT: number;
		DiscountedTotalPrice: number;
		DiscountedVat: number;
		Method: string;
		AddedProducts: PriceModelRow[] = [];
		Payments: PaymentInfo[] = [];
		ToPay: number;
		DiscountSource: DiscountModel | undefined;
		CalculationContext: string | undefined;
	}
	export class PriceModelRow {
		ArticleNo: number;
		Name: string;
		OriginalPrice: number;
		OriginalVat: number;
		Price: number;
		Vat: number;
		VatPercentage: number;
		Discount: number;
		AllowDiscount: boolean;
		AllowRefund: boolean;
		ExcludeFromSum: boolean;
		Hidden: boolean;
		IncludeCostInRentReceiptLine: boolean;
	}
	export class CurrentObjectStatusInfo {
		Id: number;
		Title: string;
		Alias: string;
		SerialNo: string;
		RentalLocationId: number;
		RentalLocationName: string;
		Status: RentalObjectStatus | undefined;
		IsEnabled: boolean;
		DisableComment: string;
		IsDeleted: boolean;
		Rentals: Period[] = [];
		Type: ObjectTypeInfoBase | undefined;
	}
	export class Period {
		PickupTime: moment.Moment;
		ReturnTime: moment.Moment;
	}
	export enum RentalFeePolicy {
		Default = 0,
		NotSameDay = 1,
		NotWithin24HR = 2,
	}
	export enum DibsPaymentStatus {
		Authorized = 1,
		Reserved = 2,
		Cancelled = 3,
		Captured = 4,
		Refunded = 5,
	}
	export enum DibsPurchaseType {
		Rental = 1,
		Deposition = 2,
		AutoCancelPenalty = 3,
		Delay = 4,
	}
	export enum DibsPaymentSuccess {
		Success = 1,
		NotFound = 2,
		FoundConflictingPayment = 3,
		Failed = 4,
		AlreadyApproved = 5,
	}
	export enum TurboPaymentAction {
		None = 0,
		Confirm = 1,
		Cancel = 2,
	}
	export enum DibsPaymentType {
		None = 0,
		Direct = 1,
		Ticket = 2,
		DirectReserve = 3,
	}
	export enum LockActivityType {
		Other = 0,
		UserUnlock = 1,
		AdminUnlock = 2,
		Unshackle = 3,
		FirmwareMode = 4,
	}
	export enum MessagePriority {
		Random = 0,
		Banner = 4,
		UrgentBanner = 5,
		Email = 10,
		Priority = 20,
		Urgent = 30,
	}
	export enum OneWayRentalObjectType {
		Large = 340,
		Small = 421,
		Medium = 422,
		XL = 423,
	}
	export enum RentalObjectStatus {
		Invalid = 0,
		Available = 1,
		Disclosed = 2,
		Service = 4,
		Late = 8,
		AvailableButBound = 16,
	}
	export enum RentalPaymentStatus {
		Default = 0,
		Unpaid = 1,
		Paid = 3,
		Reserved = 4,
		Ticket = 5,
	}
	export enum RentalStatus {
		Reserved = 0,
		Canceled = 1,
		ReservedAndBound = 50,
		Active = 100,
		Late = 150,
		Returned = 200,
		Service = -2,
		New = -1,
	}
	export enum TurboOrderStatus {
		New = 0,
		Draft = 1,
		WaitingCustomerService = 5,
		DocumentCreated = 10,
		DocumentSigned = 25,
		AnataProcessing = 50,
		Created = 100,
		Canceled = 101,
	}
	export enum AdyenDeleteResponse {
		Failure = 0,
		Success = 1,
		ActiveRecurringTokenExists = 2,
		PaymentNotFound = 3,
		AlreadyProcessed = 4,
	}
	export enum AIQueueType {
		Rental = 1,
	}
	export enum BookingErrorCode {
		Valid = 0,
		LocationNotOpen = 1,
		PeriodUnavailable = 2,
		InvalidSecurityKey = 4,
		InvalidLocation = 8,
		InvalidPrimaryObjectType = 16,
		InvalidSecondaryObjectType = 32,
		ObjectUnavailable = 64,
		IsNotCustomersRental = 128,
		ChangesNotAllowed = 256,
		InvalidCustomer = 512,
		PickupReceiptUpdated = 1024,
		CustomerIsBlocked = 2048,
		MaxBookingsPerDay = 4096,
		MaximumConcurrentBookings = 8192,
		NotEnoughBattery = 16384,
	}
	export enum ContentType {
		Email = 0,
		Sms = 1,
		General = 2,
	}
	export enum ContentFormat {
		Plain = 0,
		Html = 1,
		Razor = 2,
	}
	export enum CostType {
		BookingFee = 0,
		Rental = 1,
		Insurance = 2,
		Discount = 3,
		Extra = 4,
		DelayPenalty = 5,
		AddOn = 6,
	}
	export enum CustomerDeletionResponse {
		OK = 0,
		InvalidInput = 1,
		NoUser = 2,
		PendingBooking = 3,
		RecentBooking = 4,
		Unauthorized = 5,
		DeletedFromT4_NotFoundPayment = 6,
		AlreadyProcessed = 7,
		SubscriptionExists = 8,
	}
	export enum CustomerPaymentRules {
		Default = 0,
		Invoice = 1,
	}
	export enum CustomerType {
		Company = 1,
		Consumer = 2,
	}
	export enum DamageType {
		Issue = 0,
		Note = 1,
		SecurityCheck = 2,
	}
	export enum EntityType {
		Rental = 0,
		Customer = 1,
		Lock = 2,
		RentalObject = 3,
		RentalLocation = 4,
		Notification = 5,
	}
	export enum ImageType {
		LocationGroup = 0,
		LocationGroupPin = 1,
		ObjectType = 2,
		TypeCategory = 3,
		ServiceRequest = 4,
		PhotoAngle = 5,
		Campaign = 6,
	}
	export enum FileType {
		ServiceRequestDocument = 0,
	}
	export enum InvoiceLineType {
		BookingProvision = 0,
		PickupProvision = 1,
		WebPickupProvision = 2,
		ReturnProvision = 3,
		CustomerPayments = 4,
		InsuranceProvision = 5,
		CustomerPaymentsInsurance = 6,
		SpecialReturnProvision = 7,
		TireDebit = 20,
		TireCredit = 21,
		ParkingFee = 100,
	}
	export enum ObjectCheckupStatus {
		Ok = 0,
		RentedOut = 1,
		NotAtLocation = 2,
	}
	export enum OneWayCountingResult {
		Found = 1,
		Deleted = 2,
		NotFound = 3,
		Correct = 4,
	}
	export enum OneWayObjectTypes {
		All = 0,
		Small = 1,
		Medium = 2,
		Large = 4,
		XL = 8,
	}
	export enum OrderEntityType {
		Customer = 0,
		Contract = 1,
	}
	export enum ProductType {
		RentalObject = 0,
		SparePart = 1,
		Addon = 2,
		Default = 3,
	}
	export enum QueuedMessageCategory {
		CustomerConfirmation = 1,
		InternalNotification = 2,
		Marketing = 3,
		Reminder = 4,
		CustomerService = 6,
	}
	export enum QueuedMessageMethod {
		Notification = 1,
		Sms = 2,
		Email = 3,
	}
	export enum QueuedMessagePriority {
		Low = 1,
		Normal = 5,
		High = 10,
	}
	export enum QueuedMessageCancelReason {
		FallbackFailed = 1,
		PrimaryMethodFailedNoFallback = 2,
		FCMConfirmationTimeout = 3,
	}
	export enum QueuedMessageConditionGroup {
		All = 1,
		Any = 2,
	}
	export enum QueuedMessageConditionField {
		CustomerName = 1,
		CustomerEmail = 2,
		CustomerCountry = 3,
		CustomerPhone = 4,
		RentalId = 5,
		RentalStatus = 6,
		RentalCreatedAt = 7,
		RentalStartDate = 8,
		RentalEndDate = 9,
		Location = 10,
		Group = 11,
		LocationCountry = 12,
		Concept = 13,
	}
	export enum QueuedMessageConditionOperator {
		Equals = 1,
		NotEquals = 2,
		Contains = 3,
		NotContains = 4,
		StartsWith = 5,
		EndsWith = 6,
		GreaterThan = 7,
		GreaterThanOrEqual = 8,
		LessThan = 9,
		LessThanOrEqual = 10,
		Between = 11,
	}
	export enum UserDevicePlatform {
		Android = 1,
		Ios = 2,
	}
	export enum ReceiptType {
		Invalid = 0,
		Receipt = 1,
		Extension = 2,
		Delay = 4,
		OneWay = 8,
		Local = 16,
	}
	export enum ReceiptPickupType {
		Standard = 0,
		OneWay = 1,
		SeparateConditions = 2,
		Unmanned = 3,
		Use4Free = 4,
	}
	export enum ReceiptReturnType {
		Standard = 0,
		OneWay = 1,
		SeparateConditions = 2,
		Unmanned = 3,
		Use4Free = 4,
	}
	export enum RegisterCheckupResult {
		NoServiceGuyRole = 0,
		Success = 1,
		InvalidObject = 2,
	}
	export enum RentalEventType {
		General = 0,
		Notification = 1,
		Created = 10,
		Assigned = 20,
		Unassigned = 30,
		Confirmed = 40,
		Payment = 50,
		Disclosed = 60,
		Returned = 70,
		Sms = 500,
		Call = 501,
		Change = 502,
		Canceled = 503,
		Email = 504,
		DigitallySigned = 505,
		Unlocked = 506,
		Comment = 507,
	}
	export enum ReportInterval {
		Yearly = 0,
		Monthly = 1,
		Weekly = 2,
		Daily = 3,
	}
	export enum ReportFormat {
		Csv = 0,
		Excel = 1,
		Json = 2,
	}
	export enum ReturnResultAction {
		Unspecified = 0,
		Confirm = 10,
		Ignore = 20,
	}
	export enum ReturnValidationResult {
		Invalid = 0,
		Valid = 10,
		Changed = 20,
		Late = 30,
		WrongLocation = 40,
		InvoicePayment = 50,
	}
	export enum ServiceRequestStatus {
		New = 0,
		Updated = 3,
		Incomplete = 5,
		Received = 10,
		WaitingForDecision = 15,
		Parked = 20,
		WaitingForServiceGuy = 21,
		TransportOrdered = 25,
		ServiceRequested = 29,
		ServiceOrdered = 30,
		ReportedStolen = 35,
		SparePartRequested = 39,
		SparePartOrdered = 40,
		Expired = 45,
		ReturnOrdered = 49,
		Completed = 50,
		Canceled = 100,
		ServiceParterChanged = 200,
		Invalid = -1,
	}
	export enum ServiceRequestTags {
		None = 0,
		Missing = 1,
		Inspection = 2,
		Immobilized = 4,
		InProduction = 8,
		Hitch = 16,
		Reflex = 32,
		Lamp = 64,
		Wire = 128,
		Tyre = 256,
		Chassi = 512,
		SupportWheel = 1024,
		Lock = 2048,
		Fender = 4096,
		MudFlap = 8192,
		StolenDuringRent = 16384,
		StolenFromLocation = 32768,
		InsuranceDamageDuringRent = 65536,
		InsuranceDamageAtLocation = 131072,
		Conversion = 262144,
	}
	export enum RequestFeedbackType {
		General = 0,
		InsuranceRejection = 1,
		MoreInformationNeeded = 2,
	}
	export enum ShipmentStatus {
		Created = 1,
		LoadingStarted = 2,
		Started = 3,
		Completed = 4,
	}
	export enum SignInError {
		Success = 0,
		UserNotFound = 1,
		CustomerNotFound = 2,
		CodeNotSent = 3,
		EmailDoesNotMatchAccount = 4,
		UnknownError = 5,
		PhoneNumberAlreadyTaken = 6,
		CaptchaFailed = 7,
	}
	export enum TerminationEventType {
		PurchaseOrder = 0,
		SalesOrder = 1,
		OffRentAction = 2,
		Extension = 3,
	}
	export enum TrailerPositionProbability {
		AtStation = 1,
		PendingArrival = 2,
		Confirmed = 4,
		Preliminary = 8,
		Late = 16,
		Disabled = 32,
	}
	export enum Triggers {
		None = 0,
		OnPickup = 1,
		OnReturn = 2,
		Created = 3,
		CreatedRemotely = 4,
		CreatedInSite = 5,
		CreatedInT4 = 6,
	}
	export enum TurboHubEventType {
		Booking = 0,
		Order = 1,
		SmartLock = 2,
	}
	export enum TurboVersion {
		Standard = 0,
		Professional = 10,
		UltraDeluxe = 20,
	}
	export enum WebHookEvent {
		AddLocation = 1,
		UpdateLocation = 2,
		DeleteLocation = 4,
		AddObject = 8,
		UpdateObject = 16,
		DeleteObject = 32,
		AddServiceRequest = 64,
		UpdateServiceRequest = 128,
		DeleteServiceRequest = 256,
	}
	export enum WebHookFormat {
		Json = 0,
		Xml = 1,
	}
	export enum WebHookMessageType {
		InvoiceInfo = 0,
		RentalInfo = 1,
		RentalLocationInfo = 2,
		RentalObjectInfo = 3,
		ServiceRequestInfo = 4,
	}
	export enum WebHookDeliveryType {
		HTTP = 0,
		FTP = 1,
	}
	export enum ProductInvoiceSettings {
		TotalCount = 0,
		MultiLine = 1,
	}
	export enum ControlType {
		TextBox = 0,
		Html = 1,
		Checkbox = 2,
		Radiobutton = 3,
		Json = 4,
		TextArea = 5,
		DropDown = 6,
		Numeric = 7,
	}
	export enum EmailType {
		Confirmation = 0,
		Cancellation = 1,
		PaymentRequest = 2,
		RegisterServiceguy = 3,
		ReviewRequest = 4,
		ThankYou = 5,
		PasswordReset = 6,
		InsuranceConfirmation = 7,
		InsuranceMissingInfo = 8,
		InsuranceRejected = 9,
		InsuranceRequestComplete = 10,
		BoundConfirmation = 11,
		ServiceRequest = 12,
	}
	export enum DeviceType {
		Lock = 0,
		Tracker = 1,
		NfcTag = 2,
		DeviceNumber = 3,
	}
	export enum LocationValidationStatus {
		Valid = 0,
		GroupNotFound = 2,
	}
	export enum ObjectValidationStatus {
		Valid = 0,
		StationNotFound = 2,
		TypeNotFound = 3,
		Exception = 4,
	}
	export enum PaymentRequestStatus {
		Created = 0,
		Pending = 10,
		Expired = 50,
		Completed = 100,
		Canceled = 101,
		ManuallyInvoiced = 150,
	}
	export enum ProviderPaymentStatus {
		Authorized = 0,
		Reserved = 1,
		Captured = 2,
		Canceled = 3,
		Refunded = 4,
		Preliminary = -1,
	}
	export enum RefundResult {
		Success = 0,
		AmountToHigh = 1,
		NegativeAmount = 2,
		RefundFailed = 3,
		UnknownError = 4,
	}
	export enum ContractStatus {
		Review = 0,
		Created = 1,
		Delivered = 60,
		Terminated = 100,
		Error = 500,
	}
	export enum EntityQueueType {
		RentalOrder = 0,
		Customer = 1,
	}
	export enum IntegrationLogType {
		None = 0,
		Order = 1,
		PurchaseOrder = 2,
		SalesOrder = 3,
		Termination = 4,
		Extension = 5,
		ChangeOfOwner = 6,
		Contracts = 7,
		Customer = 8,
		Pricelist = 9,
		upcomingTrailers = 10,
	}
	export enum RepurchaseStatus {
		NoContracts = 0,
		Repurchased = 1,
		TermiantedAsAnInsuranceCase = 2,
	}
	export enum VehicleStatus {
		Produced = 0,
		OnContract = 50,
		InStore = 75,
		Sold = 100,
		Scrapped = 101,
	}
	export enum NuwielParkBrake {
		Init = 0,
		Released = 1,
		ApplyingByButton = 2,
		AbortApplyingByButton = 3,
		AppliedByButton = 4,
		ReleasingByButton = 5,
		AbortReleasingByButton = 6,
		ButtonStuck = 7,
		ApplyingByLever = 8,
		AppliedByLever = 9,
		ReleasingByLever = 10,
	}
	export enum NuwielPowerState {
		Off = 0,
		On = 1,
	}
	export enum NuwielTrailerError {
		None = 0,
		InitializationFailed = 1,
		PowerSwitchTemperatureWarning = 2,
		PowerSwitchTemperatureCritical = 3,
		VoltageMonitoringFailed = 4,
		BatteryLow = 5,
		BatteryCritical = 6,
		BatteryEmpty = 7,
		BatteryCommunicationFailed = 8,
		MotorVescFault = 9,
		MotorLoose = 10,
		ATSOutOfRange = 11,
		ATSSpike = 12,
		ATSGeneric = 13,
		PowerSwitchFailed = 14,
		MotorTemperatureHigh = 15,
		PowerManagementFailed = 16,
	}
	export enum NuwielTrailerMode {
		Startup = 0,
		Parked = 1,
		Bike = 2,
		Handcart = 3,
	}
	export enum NuwielTravelRange {
		LessThan5KM = 1,
		Between5And10KM = 2,
		Between10And20KM = 3,
		MoreThan20KM = 4,
	}
	export enum PhotoAngle {
		Front = 0,
		Back = 1,
		Inside = 2,
	}
	export enum CustomerEventType {
		Info = 0,
		Blocked = 1,
	}
	export enum LockEventType {
		Info = 0,
	}
	export enum OrderCustomerEntityType {
		Info = 0,
		Created = 1,
		Updated = 2,
		Deleted = 3,
		Invoice = 4,
	}
	export enum RentalLocationEventType {
		Info = 0,
	}
	export enum RentalObjectEventType {
		Info = 0,
		Created = 1,
		Deleted = 2,
	}
	export enum EntityType {
		ObjectType = 0,
		Category = 1,
		LocationGroup = 2,
	}
	export enum ProductPriceType {
		Fixed = 0,
		Percentage = 1,
		Specified = 2,
		FixedPerUnit = 3,
	}
	export enum CampaignType {
		Voucher = 1,
		Campaign = 2,
		Template = 3,
		InviteFriends = 4,
	}
	export enum DiscountGenerationPattern {
		Manual = 0,
		Weekly = 1,
		Monthly = 2,
		Yearly = 3,
	}
	export enum DiscountValueType {
		Percentage = 0,
		Monetary = 1,
		Time = 2,
	}
	export enum PartnerCampaignType {
		ActivationCode = 1,
		Information = 2,
		PopupAdvertisement = 3,
	}
	export enum SystemRights {
		None = 0,
		CC_ManagePrices = 1,
		CC_ManageProducts = 2,
		T4_Booking_CancelBooking = 3,
		T4_Booking_DiscloseBooking = 4,
		T4_Booking_EditBooking = 5,
		T4_Booking_Refund = 6,
		T4_Booking_ReturnBooking = 7,
		T4_Booking_SetDiscount = 8,
		T4_Booking_ViewSalesData = 9,
		T4_Fleet_ManageCategories = 10,
		T4_Fleet_ManageObjects = 11,
		T4_Fleet_ManageObjectTypes = 12,
		T4_ServiceGuy_CanConnectLocks = 13,
		T4_ServiceGuy_CanDisconnectLocks = 14,
		T4_ServiceGuy_CanUnlockLock = 15,
		T4_ServiceGuy_CanUnshackle = 16,
		T4_Settings_ChangeSettings = 17,
		T4_Settings_ManageRights = 18,
		TO_Contracts_Manage = 19,
		TO_Insurance_FollowUp = 20,
		TO_Insurance_Manage = 21,
		TO_Insurance_SetOff = 22,
		TO_Insurance_View = 23,
	}
	export enum AssetLocationStatus {
		Unknown = 0,
		StigamoLager = 1,
		ServiceGuy = 10,
		Customer = 30,
		Rented = 40,
	}
